<template>
  <div
    v-if="$page.props.processing"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25"
  >
    <div class="rounded-lg bg-white p-4 shadow-xl">
      <div class="flex items-center space-x-3">
        <svg
          class="h-5 w-5 animate-spin text-blue-600"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
        <span class="text-sm font-medium text-gray-700">Memuat...</span>
      </div>
    </div>
  </div>
  <app-layout title="Daftar Pengajuan">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Daftar Pengajuan Dokumen Pengadaan
      </h2>
    </template>

    <div class="py-12">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <!-- Rejection Note Alert -->
        <div v-if="dokumenPengadaan?.status === 'revisi' && latestRejectionNote" 
             class="mb-6 bg-red-50 border-l-4 border-red-400 p-4 rounded-lg shadow-sm">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-800">
                CATATAN Penolakan terakhir dari PPK
              </h3>
              <div class="mt-2 text-sm text-red-700">
                <p>{{ latestRejectionNote }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Evaluasi Ulang History Alert -->
        <div v-if="hasEvaluasiUlangHistory" 
             class="mb-6 bg-amber-50 border-l-4 border-amber-400 p-4 rounded-lg shadow-sm">
          <div class="flex items-center justify-between">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-amber-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-sm font-medium text-amber-800">
                  Dokumen Ini Pernah Mengalami Evaluasi Ulang
                </h3>
                <div class="mt-1 text-sm text-amber-700">
                  <p>Evaluasi sebelumnya dibatalkan karena sanggah diterima. Anda dapat melihat data historis evaluasi sebelumnya.</p>
                </div>
              </div>
            </div>
            <Button 
              label="Lihat Riwayat Evaluasi"
              icon="pi pi-history"
              severity="warning"
              size="small"
              @click="showHistoricEvaluasiModal"
              :loading="loadingRiwayatEvaluasi"
            />
          </div>
        </div>

        <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-6">
          <div class="mb-4 flex items-center">
            <button
              @click="showJadwalList"
              class="inline-flex items-center justify-center px-4 py-2 bg-purple-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-purple-700 focus:outline-none focus:border-purple-700 focus:ring focus:ring-purple-200 active:bg-purple-600 disabled:opacity-25 transition mr-2"
            >
              <svg
                class="-ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Jadwal
            </button>
            <button
              @click="showEditJadwalModal"
              class="inline-flex items-center justify-center px-4 py-2 bg-orange-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-orange-700 focus:outline-none focus:border-orange-700 focus:ring focus:ring-orange-200 active:bg-orange-600 disabled:opacity-25 transition mr-2"
            >
              <svg
                class="-ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
              Edit Jadwal
            </button>
            <button
              @click="showBaepForm"
              :disabled="isLoadingBaep || !isPenilaianAllowed"
              class="inline-flex items-center justify-center px-4 py-2 bg-blue-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-blue-700 focus:outline-none focus:border-blue-700 focus:ring focus:ring-blue-200 active:bg-blue-600 disabled:opacity-25 transition"
            >
              <svg
                v-if="isLoadingBaep"
                class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <svg
                v-else
                class="-ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              {{ hasBaep ? 'Ubah BAEP' : 'Buat BAEP' }}
            </button>
            <button
              v-if="hasPemenang(dokumenPengadaanId)"
              @click="showBahpForm"
              :disabled="isLoadingBahp "
              class="inline-flex items-center justify-center px-4 py-2 ml-2 bg-green-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-green-700 focus:outline-none focus:border-green-700 focus:ring focus:ring-green-200 active:bg-green-600 disabled:opacity-25 transition"
            >
              <svg
                v-if="isLoadingBahp"
                class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <svg
                v-else
                class="-ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              {{ hasBahp ? 'Ubah BAHP' : 'Buat BAHP' }}
            </button>

            <Button v-if="hasBaep "
              @click="showBaepModal(dokumenPengadaanId)"
              icon="pi pi-file-pdf"
              label="Lihat / Download BAEP"
              severity="success"
              size="small"
              text />

            <Button v-if="hasBahp "
              @click="showBahpModal(dokumenPengadaanId)"
              icon="pi pi-file-pdf"
              label="Lihat / Download BAHP"
              severity="success"
              size="small"
              text />
            <button
              v-if="canAjukanVerifikasiPemenang"
              @click="confirmAjukanVerifikasiPemenang"
              :disabled="isSubmittingVerifikasi"
              class="inline-flex items-center justify-center px-4 py-2 ml-2 bg-indigo-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-indigo-700 focus:outline-none focus:border-indigo-700 focus:ring focus:ring-indigo-200 active:bg-indigo-600 disabled:opacity-25 transition"
            >
              <svg
                v-if="isSubmittingVerifikasi"
                class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <svg
                v-else
                class="-ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              Ajukan Verifikasi Pemenang (ke PPK)
            </button>
            <!-- <button
              v-if="hasPemenang(dokumenPengadaanId)"
              @click="confirmResetPemenang"
              :disabled="!isSetPemenangAllowed"
              class="inline-flex items-center justify-center px-4 py-2 ml-2 bg-red-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-red-700 focus:outline-none focus:border-red-700 focus:ring focus:ring-red-200 active:bg-red-600 disabled:opacity-25 transition"
            >
              <i class="fas fa-undo-alt -ml-1 mr-2 h-4 w-4"></i>
              Reset Pemenang
            </button> -->
            <button v-if="isPpk"
              @click="showDialog"
              class="inline-flex items-center justify-center px-4 py-2 ml-2 bg-red-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-red-700 focus:outline-none focus:border-red-700 focus:ring focus:ring-red-200 active:bg-red-600 disabled:opacity-25 transition"
            >
            <!--  :disabled="['selesai','batal'].includes(dokumenPengadaan?.status)" -->
              <div v-if="['batal'].includes(dokumenPengadaan?.status)">
              </div>
              <div v-else>
                <i class="fas fa-delete-left -ml-1 mr-2 h-4 w-4"></i>
              </div>
               {{ ['batal'].includes(dokumenPengadaan?.status)?'Status : Batal' : 'Batal'}}
            </button>
           
          </div>
          <div v-if="sortedPengajuanList.length > 0">
            <!-- Sorting Info -->
            <div class="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <div class="flex items-center">
                <svg class="h-5 w-5 text-blue-400 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clip-rule="evenodd" />
                </svg>
                <span class="text-sm font-medium text-blue-800">
                  Daftar telah diurutkan berdasarkan: 
                  <span class="font-semibold">1) Status Evaluasi (Lulus terlebih dahulu)</span>, 
                  <span class="font-semibold">2) Harga Penawaran (Terendah ke Tertinggi)</span>
                </span>
              </div>
              <div class="mt-2 text-xs text-blue-600">
                • Peserta yang lulus evaluasi ditampilkan dengan latar belakang hijau dan nomor urutan biru
                • Peserta yang tidak lulus evaluasi ditampilkan dengan latar belakang abu-abu
              </div>
            </div>
            <div class="overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">No</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Penyedia</th>
                    <th scope="col" class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Total Nilai Penawaran</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status Evaluasi</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Detail Penilaian</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Keterangan</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr v-for="(pengajuan, index) in sortedPengajuanList" :key="pengajuan.id"
                      :class="pengajuan.is_lulus_evaluasi ? 'bg-green-50 border-l-4 border-green-400' : 'bg-gray-50'"
                  >
                    <td class="px-6 py-4 whitespace-nowrap text-sm">{{ index + 1 }}</td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      <div class="text-sm font-medium text-gray-900">
                        {{ pengajuan.penyedia.nama_perusahaan }}
                      </div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      {{ formatCurrency(pengajuan.detail_penawaran_kepersertaan_pengadaan ? 
                          pengajuan.detail_penawaran_kepersertaan_pengadaan.reduce(
                            (sum, item) => sum + (item.volume * item.harga_satuan), 0
                          ) : 0) }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      <!-- Overall Evaluation Status -->
                      <div class="flex items-center">
                        <!-- Rank Badge for qualified participants -->
                        <span v-if="pengajuan.is_lulus_evaluasi" 
                              class="inline-flex items-center justify-center w-8 h-8 text-sm font-bold text-white bg-blue-600 rounded-full mr-3">
                          {{ getQualifiedRank(pengajuan) }}
                        </span>
                        
                        <span :class="pengajuan.is_lulus_evaluasi ? 'bg-green-100 text-green-800 border-green-200' : 'bg-red-100 text-red-800 border-red-200'" 
                              class="px-3 py-1 text-sm font-semibold rounded-full border">
                          {{ pengajuan.is_lulus_evaluasi ? 'LULUS EVALUASI' : 'TIDAK LULUS EVALUASI' }}
                        </span>
                      </div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      <!-- Detailed Assessment Results -->
                      <div v-if="pengajuan.penilaian_penyedia_dokumen_pengadaan && pengajuan.penilaian_penyedia_dokumen_pengadaan.length > 0" class="text-sm">
                        <div v-for="(penilaian, pidx) in pengajuan.penilaian_penyedia_dokumen_pengadaan" :key="pidx" class="mb-1">
                          <span :class="penilaian.is_lulus ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'" 
                                class="px-2 py-1 text-xs font-medium rounded-full">
                            {{ penilaian.is_lulus ? 'Lulus' : 'Tidak Lulus' }}
                          </span>
                          <span class="text-xs text-gray-500 ml-1">
                            {{ penilaian.bobot_penilaian_dokumen_pengadaan ? penilaian.bobot_penilaian_dokumen_pengadaan.nama : '' }}
                          </span>
                        </div>
                      </div>
                      <div v-else class="text-sm text-gray-500">Belum dinilai</div>
                    </td>
                    <td class="px-6 py-4">
                      <div class="text-sm text-gray-900">
                        {{ pengajuan.keterangan_penilaian || '-' }}
                      </div>
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm">
                      <div class="flex space-x-2">
                        <Button v-if="undangan.isShow" @click="showUndanganModal(pengajuan)"
                               icon="pi pi-send"
                               label="Kirim Undangan"
                               severity="contrast"
                               size="small"
                               :disabled="!isPenilaianAllowed"
                               text >
                        </Button>
                        <Button @click="showDetails(pengajuan)"
                               icon="pi pi-eye"
                               label="Detail / Penilaian"
                               severity="info"
                               size="small"
                               :disabled="!isPenilaianAllowed"
                               text />
                        <Button v-show="false" @click="showKoreksi(pengajuan)"
                               icon="pi pi-pencil"
                               label="Koreksi"
                               severity="warning"
                               size="small"
                               :disabled="!isPenilaianAllowed"
                               text />
                        <!-- Winner Action Buttons - Only show for qualified participants -->
                        <button
                          v-if="!pengajuan.is_pemenang && !hasPemenang(pengajuan.dokumen_pengadaan_id) && isSetPemenangAllowed && pengajuan.is_lulus_evaluasi"
                          @click="confirmSetPemenang(pengajuan)"
                          class="ml-4 inline-flex items-center text-green-600 hover:text-green-900"
                          title="Set sebagai pemenang"
                        >
                          <i class="fas fa-trophy mr-1"></i>
                          Set Pemenang
                        </button>

                        <button
                          v-if="!pengajuan.is_pemenang && !hasPemenang(pengajuan.dokumen_pengadaan_id) && isProposePemenangAllowed && pengajuan.is_lulus_evaluasi"
                          @click="confirmProposePemenang(pengajuan)"
                          class="ml-4 inline-flex items-center text-blue-600 hover:text-blue-900"
                          title="Usulkan sebagai pemenang"
                        >
                          <i class="fas fa-hand-pointer mr-1"></i>
                          Propose Pemenang
                        </button>

                        <button
                          v-if="!pengajuan.is_pemenang && !hasPemenang(pengajuan.dokumen_pengadaan_id) && pengajuan.is_proposed_pemenang && isApprovePemenangAllowed && pengajuan.is_lulus_evaluasi"
                          @click="confirmApprovePemenang(pengajuan)"
                          class="ml-4 inline-flex items-center text-purple-600 hover:text-purple-900"
                          title="Setujui usulan pemenang"
                        >
                          <i class="fas fa-check-circle mr-1"></i>
                          Approve Pemenang
                        </button>

                        <button
                          v-if="!pengajuan.is_pemenang && !hasPemenang(pengajuan.dokumen_pengadaan_id) && pengajuan.is_proposed_pemenang && isSetPemenangKolektifAllowed && pengajuan.is_lulus_evaluasi"
                          @click="confirmSetPemenangKolektif(pengajuan)"
                          class="ml-4 inline-flex items-center text-green-600 hover:text-green-900"
                          title="Set pemenang secara kolektif"
                        >
                          <i class="fas fa-users mr-1"></i>
                          Set Pemenang (Kolektif)
                        </button>

                        <!-- Show disabled state message for unqualified participants -->
                        <span 
                          v-if="!pengajuan.is_pemenang && !hasPemenang(pengajuan.dokumen_pengadaan_id) && (isSetPemenangAllowed || isProposePemenangAllowed) && !pengajuan.is_lulus_evaluasi"
                          class="ml-4 inline-flex items-center text-gray-400"
                          title="Penyedia belum lulus evaluasi"
                        >
                          <i class="fas fa-ban mr-1"></i>
                          Belum Lulus Evaluasi
                        </span>
                        <span v-if="pengajuan.is_pemenang" class="ml-4 inline-flex items-center text-green-600">
                          <i class="fas fa-trophy mr-1"></i>
                          Pemenang
                        </span>
                        <span v-else-if="pengajuan.is_proposed_pemenang" class="ml-4 inline-flex items-center text-blue-600">
                          <i class="fas fa-user-check mr-1"></i>
                          Diusulkan Pemenang
                        </span>
                        <span v-if="pengajuan.is_proposed_pemenang && dokumenPengadaanActor && dokumenPengadaanActor.is_setuju_pemenang" class="ml-2 inline-flex items-center text-purple-600">
                          <i class="fas fa-check-circle mr-1"></i>
                          Disetujui
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else class="text-center py-4 text-gray-500">
            Tidak ada pengajuan yang ditemukan
          </div>
        </div>
      </div>
    </div>

    <!-- Detail Modal -->
    <dialog-modal :show="detailModalOpen" @close="closeModal" :max-width="'7xl'">
      <template #title>
        Detail Pengajuan
      </template>

      <template #content>
        <div v-if="selectedPengajuan" class="space-y-6">
          <!-- Penyedia Detail Ringkas -->
          <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
              <div>
                <div class="font-semibold text-gray-700">Nama Perusahaan:</div>
                <div class="text-gray-900">{{ selectedPengajuan.penyedia?.nama_perusahaan || '-' }}</div>
              </div>
              <div>
                <div class="font-semibold text-gray-700">NPWP:</div>
                <div class="text-gray-900">{{ selectedPengajuan.penyedia?.npwp_perusahaan || '-' }}</div>
              </div>
              <div>
                <div class="font-semibold text-gray-700">Direktur:</div>
                <div class="text-gray-900">{{ selectedPengajuan.penyedia?.nama_pemberi_kuasa || '-' }}</div>
              </div>
              <div>
                <div class="font-semibold text-gray-700">Alamat:</div>
                <div class="text-gray-900">{{ selectedPengajuan.penyedia?.alamat_perusahaan || '-' }}</div>
              </div>
              <div>
                <div class="font-semibold text-gray-700">Jenis Pekerjaan:</div>
                <div class="text-gray-900">{{ selectedPengajuan.penyedia?.jenis_pekerjaan?.nama_pekerjaan || '-' }}</div>
              </div>
            </div>
          </div>
          <div>
            <h3 class="text-lg font-medium text-gray-900 mb-4">Perbandingan Harga</h3>
            <div class="bg-gray-50 p-4 rounded-lg">
              <div class="overflow-x-auto">
                <table class="min-w-full">
                  <thead>
                    <tr>
                      <th class="text-left text-sm font-medium text-gray-700 pb-3">Merk/Tipe/Specs</th>
                      <th class="text-left text-sm font-medium text-gray-700 pb-3">Nama Barang/Jasa</th>
                      <th class="text-right text-sm font-medium text-gray-700 pb-3">Volume</th>
                      <th class="text-right text-sm font-medium text-gray-700 pb-3">Harga Satuan</th>
                      <th class="text-right text-sm font-medium text-gray-700 pb-3">Total Penawaran</th>
                      <th class="text-right text-sm font-medium text-gray-700 pb-3">Total HPS</th>
                      <th class="text-right text-sm font-medium text-gray-700 pb-3">Selisih</th>
                      <th class="text-right text-sm font-medium text-gray-700 pb-3">Perbandingan</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(hps, index) in selectedPengajuan.dokumen_pengadaan.detail_hps_dokumen_pengadaan" :key="hps.id"
                        class="border-b border-gray-200">
                      <td class="py-2 text-sm text-gray-600">{{
                        selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index] ?
                        [
                          selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].merk,
                          selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].tipe,
                          selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].spesifikasi
                        ].filter(Boolean).join(' - ') || selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].uraian
                        : '-'
                      }}</td>
                      <td class="py-2 text-sm text-gray-600">{{ hps.nama_barang_jasa }}</td>
                      <td class="py-2 text-right text-sm font-medium">
                        {{ selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index]?.volume || '-' }}
                      </td>
                      <td class="py-2 text-right text-sm font-medium">
                        {{ selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index]
                          ? 'Rp ' + formatNumber(selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].harga_satuan)
                          : '-' }}
                      </td>
                      <td class="py-2 text-right text-sm font-medium">
                        {{ selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index]
                          ? 'Rp ' + formatNumber(selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].volume *
                                               selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].harga_satuan)
                          : '-' }}
                      </td>
                      <td class="py-2 text-right text-sm font-medium">Rp {{ formatNumber(hps.volume * hps.harga_satuan) }}</td>
                      <td class="py-2 text-right text-sm font-medium"
                          :class="selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index] &&
                                 (selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].volume *
                                  selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].harga_satuan) >
                                 (hps.volume * hps.harga_satuan)
                                 ? 'text-red-600' : 'text-green-600'">
                        {{ selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index]
                          ? 'Rp ' + formatNumber((selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].volume *
                                                selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].harga_satuan) -
                                               (hps.volume * hps.harga_satuan))
                          : '-' }}
                      </td>
                      <td class="py-2 text-right text-sm font-medium">
                        <div v-if="selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index]"
                             class="flex items-center justify-end space-x-1"
                             :class="getPercentageDiff(
                               selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].volume *
                               selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].harga_satuan,
                               hps.volume * hps.harga_satuan
                             ) > 0 ? 'text-red-600' : 'text-green-600'">
                          <span class="font-medium">
                            {{ Math.abs(getPercentageDiff(
                              selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].volume *
                              selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].harga_satuan,
                              hps.volume * hps.harga_satuan
                            )).toFixed(2) }}%
                          </span>
                          <svg v-if="getPercentageDiff(
                            selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].volume *
                            selectedPengajuan.detail_penawaran_kepersertaan_pengadaan[index].harga_satuan,
                            hps.volume * hps.harga_satuan
                          ) > 0"
                            class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
                          </svg>
                          <svg v-else
                            class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                          </svg>
                        </div>
                        <span v-else>-</span>
                      </td>
                    </tr>
                    <!-- Total Row -->
                    <tr class="border-t-2 border-gray-300 font-semibold">
                      <td class="py-3 text-sm text-gray-700">Total</td>
                      <td class="py-3 text-right text-sm">-</td>
                      <td class="py-3 text-right text-sm">-</td>
                      <td class="py-3 text-right text-sm">-</td>
                      <td class="py-3 text-right text-sm">
                        Rp {{ formatNumber(selectedPengajuan.detail_penawaran_kepersertaan_pengadaan.reduce((sum, item) =>
                          sum + (item.volume * item.harga_satuan), 0)) }}
                      </td>
                      <td class="py-3 text-right text-sm">
                        Rp {{ formatNumber(selectedPengajuan.dokumen_pengadaan.detail_hps_dokumen_pengadaan.reduce((sum, item) =>
                          sum + (item.volume * item.harga_satuan), 0)) }}
                      </td>
                      <td class="py-3 text-right text-sm"
                          :class="getTotalSelisih > 0 ? 'text-red-600' : 'text-green-600'">
                        Rp {{ formatNumber(getTotalSelisih) }}
                      </td>
                      <td class="py-3 text-right text-sm">
                        <div class="flex items-center justify-end space-x-1"
                             :class="getTotalPercentageDiff > 0 ? 'text-red-600' : 'text-green-600'">
                          <span class="font-medium">{{ Math.abs(getTotalPercentageDiff).toFixed(2) }}%</span>
                          <svg v-if="getTotalPercentageDiff > 0"
                            class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
                          </svg>
                          <svg v-else
                            class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                          </svg>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-if="!isKoreksiMode && hasPenilaian" class="mb-4 rounded-md bg-yellow-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-sm font-medium text-yellow-800">Penilaian Sudah Ada</h3>
                <div class="mt-2 text-sm text-yellow-700">
                  <p>
                    Pengajuan ini sudah memiliki penilaian sebelumnya. Menyimpan penilaian baru akan menggantikan penilaian yang sudah ada.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!isKoreksiMode">
            <h3 class="text-lg font-medium text-gray-900 mb-4">Penilaian</h3>
            <div class="bg-gray-50 p-4 rounded-lg">
              <div class="space-y-4">
                <div v-for="bobot in selectedPengajuan?.dokumen_pengadaan?.bobot_penilaian_dokumen_pengadaan || []"
                     :key="bobot.id" class="border-b border-gray-200 pb-4">
                  <div class="flex items-center justify-between mb-2">
                    <label :for="'nilai-' + bobot.id" class="block text-sm font-medium text-gray-700">
                      {{ bobot.jenis_bobot_penilaian?.nama_jenis_bobot || '-' }} ({{ bobot.persentase_bobot }}%)
                    </label>
                    <div class="flex items-center space-x-4">
                      <div class="flex items-center space-x-2">
                        <input type="number"
                               :id="'nilai-' + bobot.id"
                               v-model.number="penilaianForm[bobot.id]"
                               min="0"
                               max="100"
                               class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-20 sm:text-sm border-gray-300 rounded-md"
                               @input="validateNilai($event, bobot.id)">
                        <span class="text-sm text-gray-500">/ 100</span>
                      </div>
                      <div class="flex items-center">
                        <input type="checkbox"
                               :id="'lulus-' + bobot.id"
                               v-model="penilaianLulus[bobot.id]"
                               @change="onLulusChange(bobot.id)"
                               class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded">
                        <label :for="'lulus-' + bobot.id" class="ml-2 block text-sm text-gray-700">
                          Lulus
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="text-sm text-gray-500">
                    Nilai Akhir: {{ ((penilaianForm[bobot.id] || 0) * bobot.persentase_bobot / 100).toFixed(2) }}
                  </div>
                </div>

                <!-- Total Score -->
                <div class="pt-4 border-t-2 border-gray-300">
                  <div class="flex items-center justify-between">
                    <span class="text-lg font-medium text-gray-900">Total Nilai</span>
                    <span class="text-lg font-medium"
                          :class="getTotalNilai >= 60 ? 'text-green-600' : 'text-red-600'">
                      {{ getTotalNilai.toFixed(2) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isKoreksiMode">
            <h3 class="text-lg font-medium text-gray-900 mb-4">Koreksi Penawaran</h3>
            <div v-if="hasExistingKoreksi" class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4" role="alert">
              <p class="font-bold">Informasi</p>
              <p>Data koreksi sudah ada. Perubahan yang dilakukan akan mengupdate data koreksi yang sudah ada.</p>
            </div>

            <div class="bg-gray-50 p-4 rounded-lg">
              <div class="overflow-x-auto">
                <table class="min-w-full">
                  <thead>
                    <tr class="border-b border-gray-200">
                      <th class="py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Merk/Tipe/Specs</th>
                      <th class="py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Volume</th>
                      <th class="py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Harga Satuan</th>
                      <th class="py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Harga Total</th>
                      <th class="py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Harga Satuan Koreksi</th>
                      <th class="py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Harga Total Koreksi</th>
                      <th class="py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Alasan Koreksi</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="detail in selectedPengajuan.detail_penawaran_kepersertaan_pengadaan" :key="detail.id">
                      <td class="py-3 text-sm">{{ [detail.merk, detail.tipe, detail.spesifikasi].filter(Boolean).join(' - ') || detail.nama_item }}</td>
                      <td class="py-3 text-sm">{{ detail.volume }}</td>
                      <td class="py-3 text-right text-sm">{{ 'Rp ' + formatNumber(detail.harga_satuan) }}</td>
                      <td class="py-3 text-right text-sm">{{ 'Rp ' + formatNumber(detail.volume * detail.harga_satuan) }}</td>
                      <td class="py-3">
                        <input
                          type="text"
                          v-model="koreksiForm[detail.id].harga_satuan_sesudah"
                          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                          @input="handlePriceInput($event, detail.id)"
                        >
                      </td>
                      <td class="py-3 text-right text-sm">
                        {{ 'Rp ' + formatNumber(detail.volume * koreksiForm[detail.id]?.harga_satuan_sesudah || 0) }}
                      </td>
                      <td class="py-3">
                        <input
                          type="text"
                          v-model="koreksiForm[detail.id].alasan_koreksi"
                          class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                        >
                      </td>
                    </tr>
                    <tr class="bg-gray-50 font-semibold">
                      <td class="py-3 text-sm" colspan="3">Total</td>
                      <td class="py-3 text-right text-sm">
                        {{ 'Rp ' + formatNumber(totalSebelumKoreksi) }}
                      </td>
                      <td class="py-3 text-right text-sm">-</td>
                      <td class="py-3 text-right text-sm">
                        {{ 'Rp ' + formatNumber(totalKoreksi) }}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div>
            <h3 class="text-lg font-medium text-gray-900 mb-2">Dokumen</h3>
            <div class="bg-gray-50 p-4 rounded-lg max-w-2xl">
              <div class="space-y-2">
                <div v-for="file in selectedPengajuan.file_kepersertaan_pengadaan" :key="file.id"
                     class="flex items-center p-2 hover:bg-gray-100 rounded-lg group">
                  <div class="flex-grow min-w-0">
                    <span class="text-sm text-gray-900 font-medium block truncate">{{ file.file_kepersertaan_pengadaan_type.nama }}</span>
                    <span class="text-sm text-gray-500 block truncate">{{ file.nama_file }}</span>
                  </div>
                  <a :href="route('file.download_file_kepersertaan', file.id)"
                     class="ml-4 shrink-0 inline-flex items-center px-2.5 py-1.5 text-sm text-indigo-600 hover:text-indigo-900 hover:bg-indigo-50 rounded-md"
                     download>
                    <svg class="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V3"/>
                    </svg>
                    Download
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 class="text-lg font-medium text-gray-900 mb-4">Keterangan</h3>
            <textarea v-model="catatan" rows="4"
                      class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      placeholder="Masukkan catatan..."></textarea>
          </div>

        </div>
      </template>

      <template #footer>
        <div class="flex justify-end space-x-4 mt-4">
          <button
            type="button"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:border-blue-700 focus:ring focus:ring-blue-200 active:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
            @click="isKoreksiMode ? saveKoreksi() : savePenilaian()"
            :disabled="isSubmitting"
          >
            <svg
              v-if="isSubmitting"
              class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{ isSubmitting ? 'Menyimpan...' : (isKoreksiMode ? 'Simpan Koreksi' : 'Simpan Penilaian') }}
          </button>
          <button
            type="button"
            class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
            @click="detailModalOpen = false"
            :disabled="isSubmitting"
          >
            Batal
          </button>
        </div>
      </template>
    </dialog-modal>

    <!-- Jadwal List Modal -->
    <dialog-modal :show="jadwalModalOpen" @close="closeJadwalModal" :max-width="'4xl'">
      <template #title>
        Jadwal Pengadaan
      </template>

      <template #content>
        <div class="space-y-6">
          <div>
            <h3 class="text-lg font-medium text-gray-900 mb-4">Daftar Jadwal</h3>
            <div class="bg-gray-50 p-4 rounded-lg">
              <div class="overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-100">
                    <tr>
                      <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">No</th>
                      <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Jadwal</th>
                      <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Waktu Mulai</th>
                      <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Waktu Selesai</th>
                      <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="(jadwal, index) in listJadwal" :key="index">
                      <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-500">{{ index + 1 }}</td>
                      <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{{ formatJadwalName(jadwal) }}</td>
                      <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-500">{{ formatDateTime(jadwal.pelaksanaan_jadwal.waktu_mulai) }}</td>
                      <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-500">{{ formatDateTime(jadwal.pelaksanaan_jadwal.waktu_selesai) }}</td>
                      <td class="px-4 py-3 whitespace-nowrap text-sm">
                        <span
                          :class="jadwal.is_constraint_allowed ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
                          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                        >
                          {{ jadwal.is_constraint_allowed ? 'Aktif' : 'Tidak Aktif' }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- Status Constraint -->
          <div>
            <h3 class="text-lg font-medium text-gray-900 mb-4">Status Constraint</h3>
            <div class="bg-gray-50 p-4 rounded-lg">
              <div class="grid grid-cols-1 gap-4">
                <div v-for="(isAllowed, constraint) in filterConstraints(listConstraint)" :key="constraint"
                    class="border rounded-lg p-4 shadow-sm"
                    :class="isAllowed ? 'border-green-300 bg-green-50' : 'border-red-300 bg-red-50'">
                  <div class="flex items-center justify-between mb-2">
                    <span class="text-sm font-medium">{{ formatConstraintName(constraint) }}</span>
                    <span
                      :class="isAllowed ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                    >
                      {{ isAllowed ? 'Diizinkan' : 'Tidak Diizinkan' }}
                    </span>
                  </div>
                  <div class="text-xs text-gray-600">
                    <div>Jadwal terkait:</div>
                    <ul class="pl-2 mt-1">
                      <li v-for="jadwal in getJadwalsForConstraint(constraint)" :key="jadwal.jadwal.kode_tahap" class="flex items-center">
                        <span :class="jadwal.is_constraint_allowed ? 'text-green-600' : 'text-red-600'" class="mr-1">
                          <svg class="inline-block h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </span>
                        {{ formatJadwalName(jadwal) }} ({{ formatDateTime(jadwal.pelaksanaan_jadwal.waktu_mulai) }} - {{ formatDateTime(jadwal.pelaksanaan_jadwal.waktu_selesai) }})
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <button
          @click="closeJadwalModal"
          class="inline-flex items-center px-4 py-2 bg-gray-500 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-600 focus:outline-none focus:border-gray-600 focus:ring focus:ring-gray-200 active:bg-gray-500 disabled:opacity-25 transition"
        >
          Tutup
        </button>
      </template>
    </dialog-modal>

    <!-- BAEP Form Modal -->
    <dialog-modal :show="baepFormOpen" @close="closeBaepForm" :closeable="false">
      <template #title>
        Form Berita Acara Evaluasi Penawaran
      </template>

      <template #content>
        <div class="space-y-4">
          <div v-if="hasBaep" class="mb-4 rounded-md bg-blue-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-sm font-medium text-blue-800">Informasi BAEP</h3>
                <div class="mt-2 text-sm text-blue-700">
                  <p>BAEP sudah pernah diisi sebelumnya. Perubahan yang dilakukan akan mengupdate data BAEP yang sudah ada.</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <label for="nomor_baep" class="block text-sm font-medium text-gray-700">Nomor BAEP</label>
            <input
              type="text"
              id="nomor_baep"
              v-model="baepForm.nomor_baep"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label for="tanggal_baep" class="block text-sm font-medium text-gray-700">Tanggal BAEP</label>
            <Calendar
              v-model="baepForm.tanggal_baep"
              dateFormat="dd/mm/yy"
              :showIcon="true"
              class="w-full"
              inputClass="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <!-- Attendance Section -->
          <div class="mt-6">
            <h3 class="text-lg font-medium text-gray-900 mb-4">Daftar Hadir</h3>
            <div v-if="isLoadingActors" class="flex items-center justify-center p-4">
              <svg class="animate-spin h-5 w-5 text-blue-600 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span class="text-sm text-gray-700">Memuat daftar hadir...</span>
            </div>
            <div v-else class="space-y-6">
              <template v-for="(actors, roleName) in actorsByRole" :key="roleName" >
                <div v-if="roleName ==='pokja'" class="bg-gray-50 p-4 rounded-lg">
                  <h4 class="font-medium text-gray-700 mb-3">{{ roleName }}</h4>
                  <div class="space-y-2">
                    <div v-for="actor in actors" :key="actor.id" class="flex items-center">
                      <Checkbox
                        v-model="actor.is_hadir_bahp"
                        :binary="true"
                        :inputId="'actor-' + actor.id"
                      />
                      <label :for="'actor-' + actor.id" class="ml-2 text-sm text-gray-700">
                        {{ actor.user.name }}
                      </label>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <button
          @click="saveBaep"
          :disabled="isSubmitting"
          class="inline-flex items-center px-4 py-2 bg-blue-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-blue-700 focus:outline-none focus:border-blue-700 focus:ring focus:ring-blue-200 active:bg-blue-600 disabled:opacity-25 transition"
        >
          <svg
            v-if="isSubmitting"
            class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Simpan
        </button>
        <button
          type="button"
          class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
          @click="closeBaepForm"
          :disabled="isSubmitting"
        >
          Batal
        </button>
      </template>
    </dialog-modal>

    <!-- BAHP Form Modal -->
    <dialog-modal :show="bahpFormOpen" @close="closeBahpForm">
      <template #title>
        Form Berita Acara Hasil Pemilihan
      </template>

      <template #content>
        <div class="space-y-6">
          <div v-if="hasBahp" class="mb-4 rounded-md bg-blue-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-sm font-medium text-blue-800">Informasi BAHP</h3>
                <div class="mt-2 text-sm text-blue-700">
                  <p>BAHP sudah pernah diisi sebelumnya. Perubahan yang dilakukan akan mengupdate data BAHP yang sudah ada.</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <label for="nomor_bahp" class="block text-sm font-medium text-gray-700">Nomor BAHP</label>
            <input
              type="text"
              id="nomor_bahp"
              v-model="bahpForm.nomor_bahp"
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
            />
          </div>

          <div>
            <label for="tanggal_bahp" class="block text-sm font-medium text-gray-700">Tanggal BAHP</label>
            <Calendar
              v-model="bahpForm.tanggal_bahp"
              dateFormat="dd/mm/yy"
              :showIcon="true"
              class="w-full"
              inputClass="w-full"
            />
          </div>

          <div class="mt-6">
            <h3 class="text-lg font-medium text-gray-900 mb-4">Daftar Hadir</h3>
            <div v-if="isLoadingActors" class="flex items-center justify-center p-4">
              <svg class="animate-spin h-5 w-5 text-blue-600 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span class="text-sm text-gray-700">Memuat daftar hadir...</span>
            </div>

            <div v-else class="space-y-6">
              <template v-for="(actors, roleName) in actorsByRole" :key="roleName">
                <div v-if="roleName === 'pokja'" class="bg-gray-50 p-4 rounded-lg">
                  <h4 class="font-medium text-gray-700 mb-3">{{ roleName }}</h4>
                  <div class="space-y-2">
                    <div v-for="actor in actors" :key="actor.id" class="flex items-center">
                      <Checkbox
                        v-model="actor.is_hadir_bahp"
                        :binary="true"
                        :inputId="'actor-' + actor.id"
                      />
                      <label :for="'actor-' + actor.id" class="ml-2 text-sm text-gray-700">
                        {{ actor.user.name }}
                      </label>
                    </div>
                  </div>
                </div>
              </template>
            </div>

          </div>

          <!-- <div v-if="!isLoadingActors && Object.keys(actorsByRole).length > 0">
            <h3 class="text-lg font-medium text-gray-900 mb-4">Kehadiran</h3>
            <div v-for="(actors, roleName) in actorsByRole" :key="roleName" class="mb-4">
              <h4 class="text-sm font-medium text-gray-700 mb-2">{{ roleName }}</h4>
              <div class="space-y-2">
                <div v-for="actor in actors" :key="actor.id" class="flex items-center">
                  <input
                    type="checkbox"
                    :id="'actor-bahp-' + actor.id"
                    :checked="bahpForm.attendees.includes(actor.id)"
                    @change="toggleBahpAttendance(actor.id)"
                    class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                  <label :for="'actor-bahp-' + actor.id" class="ml-3 block text-sm font-medium text-gray-700">
                    {{ actor.user.name }} ({{ actor.user.fullname }})
                  </label>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </template>

      <template #footer>
        <button
          @click="saveBahp"
          :disabled="isSubmitting"
          class="inline-flex items-center px-4 py-2 bg-blue-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-blue-700 focus:outline-none focus:border-blue-700 focus:ring focus:ring-blue-200 active:bg-blue-600 disabled:opacity-25 transition"
        >
          <svg
            v-if="isSubmitting"
            class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Simpan
        </button>
      </template>
    </dialog-modal>

    <!-- Undangan Modal -->
    <dialog-modal :show="undanganModalOpen" @close="closeUndangan" :closeable="false">
      <template  #title>
        <div v-if="selectedPenyedia.undangan_klarifikasi_status === 'Terkirim'" >
          Pengiriman Undangan Klarifikasi & Pembuktian Klarifikasi
        </div>
        <div v-else >
          Form Setting Undangan Klarifikasi
      </div>
      </template>

      <template #content>
        <div class="space-y-6">
          {{ hasUndangan }}
          <div v-if="!hasUndangan" class="mb-4 rounded-md bg-blue-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <div class="space-y-6">
                  <h3 class="text-sm font-medium text-blue-800 pb-0 mb-0">Informasi</h3>
                  <div class="mt-0 text-sm text-orange-700 bg-yellow-50 border border-gray-500 rounded-md p-4">
                    <div v-if="selectedPenyedia.undangan_klarifikasi_waktu_mulai">
                      <p>Status Undangan : {{ !['Terkirim','Terbaca','Hadir'].includes(selectedPenyedia.undangan_klarifikasi_status) ? 'Belum terkirim' : selectedPenyedia.undangan_klarifikasi_status }}</p>
                      <p>Terkirim pada : {{ selectedPenyedia.undangan_klarifikasi_sent_at }}</p>
                    </div>
                    <div v-else>
                      <p class="mt-0 mb-0">Mohon isi form berikut terkait undangan klarifikasi</p>
                    </div>
                  </div>
                  <div class="mt-0 text-sm text-orange-700 bg-yellow-50 border border-gray-500 rounded-md p-4">
                    <p class="mt-0 mb-0">Pastikan semua data sudah benar dan Simpan Undangan sebelum mengirim undangan.</p>
                  </div>
                  <div>
                    <label for="tempat" class="block text-sm font-medium text-gray-700">Tempat</label>
                    <Textarea  autoResize rows="5" cols="30" id="tempat" v-model="undangan.tempat"
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                    />
                  </div>
                  <div>
                    <label for="waktuMulai" class="block text-sm font-medium text-gray-700">Waktu Mulai</label>
                    <Calendar ref="waktuMulaiCalendar"  v-model="undangan.waktuMulai"
                      dateFormat="dd/mm/yy"
                      :showIcon="true"
                      :showTime="true"
                      class="w-full"
                      inputClass="w-full"
                     :manualInput="false"
                    >
                    <template #footer>
                      <div class="p-3 border-t border-gray-200">
                        <div class="flex justify-between items-center">
                          <button
                            type="button"
                            @click="cancelWaktuMulaiSelection"
                            class="px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Batal
                          </button>
                          <button
                            type="button"
                            @click="confirmWaktuMulaiSelection"
                            :disabled="!undangan.waktuMulai"
                            class="px-3 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Pilih
                          </button>
                        </div>
                      </div>
                    </template>
                  </Calendar>
                  </div>
                  <div>
                    <label for="waktuAkhir" class="block text-sm font-medium text-gray-700">Waktu Akhir</label>
                    <Calendar ref="waktuAkhirCalendar"
                      v-model="undangan.waktuAkhir"
                      dateFormat="dd/mm/yy"
                      :showIcon="true"
                      :showTime="true"
                      class="w-full"
                      inputClass="w-full"
                      :manualInput="false"
                    >
                    <template #footer>
                      <div class="p-3 border-t border-gray-200">
                        <div class="flex justify-between items-center">
                          <button
                            type="button"
                            @click="cancelWaktuAkhirSelection"
                            class="px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          >
                            Batal
                          </button>
                          <button
                            type="button"
                            @click="confirmWaktuAkhirSelection"
                            :disabled="!undangan.waktuAkhir"
                            class="px-3 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            Pilih
                          </button>
                        </div>
                      </div>
                    </template>
                  </Calendar>
                  </div>
                  <div>
                    <label for="disiapkan" class="block text-sm font-medium text-gray-700">Yang harus disiapkan</label>
                    <Textarea autoResize rows="5" cols="30"
                      id="disiapkan"
                      v-model="undangan.disiapkan"
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                    />
                  </div>
                  <div>
                    <label for="hadir" class="block text-sm font-medium text-gray-700">Yang harus hadir</label>
                    <Textarea autoResize rows="5" cols="30"
                      id="hadir"
                      v-model="undangan.hadir"
                      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="mb-4 rounded-md bg-stone-200 p-4">
            <div class="ml-3">
              <h3 class="text-sm font-medium text-black"><b>Informasi Pengiriman</b></h3>
              <table class="mt-3 text-sm text-slate-800  table">
                <tr>
                  <td>Status Email</td>
                  <td class="p-2">:</td>
                  <td v-if="selectedPenyedia.undangan_klarifikasi_status === 'Terkirim'" class=" bg-sky-500 text-white text-center" >{{ selectedPenyedia.undangan_klarifikasi_status }}</td>
                  <td v-else-if="selectedPenyedia.undangan_klarifikasi_status === 'Terbaca'" class=" bg-rose-500 text-white text-center" >{{ selectedPenyedia.undangan_klarifikasi_status }}</td>
                </tr>
                <tr>
                  <td>Dikirim pada</td>
                  <td class="p-2">:</td>
                  <td>{{ selectedPenyedia.undangan_klarifikasi_sent_at }}</td>
                </tr>
                <tr>
                  <td>Dibaca pada</td>
                  <td class="p-2">:</td>
                  <td>{{ selectedPenyedia.undangan_klarifikasi_read_at}}</td>
                </tr>
                <tr>
                  <td>Tempat</td>
                  <td class="p-2">:</td>
                  <td>{{ selectedPenyedia.undangan_klarifikasi_tempat}}</td>
                </tr>
                <tr>
                  <td>Waktu</td>
                  <td class="p-2">:</td>
                  <td>{{ new Date(selectedPenyedia.undangan_klarifikasi_waktu_mulai).toLocaleString('id-ID', { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }) }} s/d {{ new Date(selectedPenyedia.undangan_klarifikasi_waktu_akhir).toLocaleString('id-ID', { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }) }}</td>
                </tr>
                <tr>
                  <td>Yang harus disiapkan</td>
                  <td class="p-2">:</td>
                  <td>{{ selectedPenyedia.undangan_klarifikasi_disiapkan}}</td>
                </tr>
                <!-- <tr>
                  <td>File Klarifikasi</td>
                  <td class="p-2">:</td>
                    <td>
                      <div v-if="selectedPenyedia.file_klarifikasi" class="flex items-center space-x-2">tes
                        <Button
                          icon="pi pi-eye"
                          label="Lihat File"
                          severity="primary"
                          size="small"
                          @click="viewKlarifikasiFile(selectedPenyedia.id)"
                          text="lihat file"
                        />
                      </div>
                      <div v-else class="flex items-center space-x-2">
                        <div>
                          <div>
                            <FileUpload
                                v-model="fileKlarifikasi"
                                id="fileKlarifikasi"
                                file_input_title="Upload file klarifikasi"
                                :maxFileSize="2000000"
                              />
                            <small class="text-gray-500">Format: PDF</small>
                          </div>
                          <div class="flex items-center space-x-2">
                            <Button
                              icon="pi pi-save"
                              label="Upload File"
                              severity="primary"
                              size="small"
                              @click="uploadFileKlarifikasi(selectedPenyedia)"
                              text="Upload file"
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                </tr> -->
              </table>
              </div>
          </div>
        </div>
      </template>

      <template #footer>
        <button v-if="undangan.waktuMulai && !['Hadir'].includes( selectedPenyedia.undangan_klarifikasi_status)"
          @click="kirimUndangan(selectedPenyedia)"
          :disabled="isSubmitting"
          class="inline-flex items-center mx-1 px-4 py-2 bg-green-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-green-700 focus:outline-none focus:border-green-700 focus:ring focus:ring-green-200 active:bg-green-600 disabled:opacity-25 transition"
        >
          <svg
            v-if="isSubmitting"
            class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Kirim Undangan
        </button>
        <button v-if="[null,'Terkirim'].includes(selectedPenyedia.undangan_klarifikasi_status)"
            @click="setUndangan(selectedPenyedia)"
            :disabled="isSubmitting"
            class="inline-flex items-center mx-1 px-4 py-2 bg-blue-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-blue-700 focus:outline-none focus:border-blue-700 focus:ring focus:ring-blue-200 active:bg-blue-600 disabled:opacity-25 transition"
          >
            <svg
              v-if="isSubmitting"
              class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Simpan Undangan
          </button>
        <button
          type="button"
          class="inline-flex items-center mx-1 px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
          @click="closeUndangan"
          :disabled="isSubmitting"
        >
          Batal
        </button>
      </template>
    </dialog-modal>

    <dialog-modal v-if="pdfModalOpen" :show="pdfModalOpen" @close="closePdfModal" :max-width="'7xl'">
      <template #title>
        File Klarifikasi
      </template>

      <template #content>
        <div v-if="isLoadingPdf" class="flex justify-center items-center h-96">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
        <div v-else-if="pdfError" class="flex justify-center items-center h-96 text-red-600">
          {{ pdfError }}
        </div>
        <div v-else class="h-[800px]">
          <iframe
            v-if="pdfUrl"
            :src="pdfUrl"
            class="w-full h-full"
            type="application/pdf"
          >
          </iframe>
        </div>
      </template>

      <template #footer>
        <button
          type="button"
          class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          @click="closePdfModal"
        >
          Tutup
        </button>
      </template>
    </dialog-modal>

    <Toast position="top-right" />
    <ProgressBar v-if="confirmSetPemenangProgress" :value="confirmSetPemenangProgress" :showValue="false" />

    <!-- BAEP Modal -->
    <dialog-modal :show="baepModalOpen" @close="closeBaepModal" :max-width="'7xl'" :closeable="false">
      <template #title>
        Berita Acara Evaluasi Penawaran
      </template>

      <template #content>
        <BeritaAcaraEvaluasiPenawaran
          :dokumen_pengadaan_id="dokumenPengadaanId"
        />
      </template>

      <template #footer>
        <div class="flex justify-end space-x-4">
          <button
            @click="closeBaepModal"
            class="inline-flex items-center px-4 py-2 bg-gray-300 border border-transparent rounded-md font-semibold text-xs text-gray-700 uppercase tracking-widest hover:bg-gray-400 focus:outline-none focus:border-gray-400 focus:ring focus:ring-gray-200 active:bg-gray-300 disabled:opacity-25 transition"
          >
            Tutup
          </button>
        </div>
      </template>
    </dialog-modal>

    <!-- BAHP Modal -->
    <dialog-modal :show="bahpModalOpen" @close="closeBahpModal" :max-width="'7xl'" :closeable="false">
      <template #title>
        Berita Acara Hasil Penawaran
      </template>

      <template #content>
        <BeritaAcaraHasilPenawaran
          :dokumen_pengadaan_id="dokumenPengadaanId"
        />
      </template>

      <template #footer>
        <div class="flex justify-end space-x-4">
          <button
            @click="closeBahpModal"
            class="inline-flex items-center px-4 py-2 bg-gray-300 border border-transparent rounded-md font-semibold text-xs text-gray-700 uppercase tracking-widest hover:bg-gray-400 focus:outline-none focus:border-gray-400 focus:ring focus:ring-gray-200 active:bg-gray-300 disabled:opacity-25 transition"
          >
            Tutup
          </button>
        </div>
      </template>
    </dialog-modal>
    
    <!-- Edit Jadwal Modal -->
    <dialog-modal :show="editJadwalModalOpen" @close="closeEditJadwalModal" max-width="2xl">
      <template #title>
        Edit Jadwal Pengadaan
      </template>

      <template #content>
        <div class="p-4">
          <div v-if="loadingJadwal" class="flex justify-center my-8">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          </div>
          <div v-else>
            <div class="mb-6">
              <label for="jadwal-selection" class="block text-sm font-medium text-gray-700 mb-1">Pilih Jadwal</label>
              <select
                id="jadwal-selection"
                v-model="selectedJadwalId"
                @change="onJadwalSelected"
                class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              >
                <option value="" disabled>Pilih Jadwal</option>
                <option
                  v-for="jadwal in jadwalList"
                  :key="jadwal.id"
                  :value="jadwal.id"
                  :disabled="isJadwalInPast(jadwal)"
                >
                  {{ jadwal.nama }} ({{ formatDateTime(jadwal.waktu_mulai) }})
                  <span v-if="isJadwalInPast(jadwal)">(Sudah lewat)</span>
                </option>
              </select>
              <p class="text-sm text-gray-500 mt-1">Jadwal yang sudah lewat tidak dapat diedit.</p>
            </div>

            <div v-if="editJadwalForm" class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Waktu Mulai</label>
                  <Calendar
                    v-model="editJadwalForm.waktu_mulai"
                    showTime
                    hourFormat="24"
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Waktu Selesai</label>
                  <Calendar
                    v-model="editJadwalForm.waktu_selesai"
                    showTime
                    hourFormat="24"
                    class="w-full"
                  />
                </div>
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Tempat</label>
                <input
                  type="text"
                  v-model="editJadwalForm.tempat"
                  class="mt-1 block w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm"
                />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Keterangan</label>
                <Textarea
                  v-model="editJadwalForm.keterangan"
                  rows="3"
                  class="mt-1 block w-full border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="flex justify-end space-x-3">
          <button
            @click="closeEditJadwalModal"
            class="inline-flex items-center px-4 py-2 bg-gray-300 border border-transparent rounded-md font-semibold text-xs text-gray-700 uppercase tracking-widest hover:bg-gray-400 focus:outline-none focus:border-gray-400 focus:ring focus:ring-gray-200 active:bg-gray-300 disabled:opacity-25 transition"
            :disabled="submittingJadwal"
          >
            Batal
          </button>
          <button
            @click="submitEditJadwal"
            class="inline-flex items-center px-4 py-2 bg-orange-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-orange-700 focus:outline-none focus:border-orange-700 focus:ring focus:ring-orange-200 active:bg-orange-600 disabled:opacity-25 transition"
            :disabled="!editJadwalForm || submittingJadwal"
          >
            <svg
              v-if="submittingJadwal"
              class="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Simpan
          </button>
        </div>
      </template>
    </dialog-modal>

    <!-- konfirm batal dialog -->
    <dialog-modal :show="konfirmBataldDialog" @close="tutup" :max-width="'7xl'" :closeable="false">
      <template  #title>
        <div v-if="!['selesai','batal'].includes(dokumenPengadaan?.status)">
          Konfirmasi Batal
        </div>
        <div v-else>
          Informasi Pembatalan
        </div>
      </template>

      <template #content>
        <div v-if="!['selesai','batal'].includes(dokumenPengadaan?.status)" class="p-4">
            <p>Apakah Anda yakin ingin membatalkan dokumen pengadaan ini?</p>
             <div class="mt-2 text-yellow-600">
                  <i class="pi pi-info-circle mr-2"></i>
                  <span>Silahkan isi keterangan berikut :</span>
              </div>
            <textarea v-model="catatan" rows="4" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
placeholder="Masukkan catatan..."></textarea>
        </div>
        <div v-else class="p-4">
          <p>Dokumen pengadaan ini sudah dibatalkan dengan keterangan:</p>
          <p class="text-red-600 font-bold">{{ dokumenPengadaan.keterangan_pembatalan }}</p>
        </div>
      </template>

      <template #footer>
        <div class="flex justify-end space-x-4">
          <button
            @click="tutup"
            class="inline-flex items-center px-4 py-2 bg-gray-300 border border-transparent rounded-md font-semibold text-xs text-gray-700 uppercase tracking-widest hover:bg-gray-400 focus:outline-none focus:border-gray-400 focus:ring focus:ring-gray-200 active:bg-gray-300 disabled:opacity-25 transition"
          >
            <div v-if="['selesai','batal'].includes(dokumenPengadaan?.status)">
              Tutup
            </div>
            <div v-else>
              Tidak
            </div>
          </button>
          <button v-if="!['selesai','batal'].includes(dokumenPengadaan?.status)"
            @click="confirmBatal" :disabled="!isFormValid"
            class="inline-flex items-center px-4 py-2 bg-blue-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-blue-700 focus:outline-none focus:border-blue-700 focus:ring focus:ring-blue-200 active:bg-blue-600 disabled:opacity-25 transition"
          >
            Iya
          </button>
        </div>
      </template>
    </dialog-modal>
    <!-- Edit Jadwal Modal -->  
    <DialogModal :show="editJadwalModalOpen" @close="closeEditJadwalModal">
      <template #title>
        Edit Jadwal
      </template>
      <template #content>
        <div class="mt-4">
          <div v-if="loadingJadwal" class="flex justify-center">
            <svg class="animate-spin h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
          <div v-else>
            <div class="mb-4">
              <label class="block text-gray-700 text-sm font-bold mb-2" for="jadwal-select">
                Pilih Jadwal
              </label>
              <!-- Using a standard select element as a fallback -->
              <select 
                v-if="jadwalList.length > 0" 
                v-model="selectedJadwalId" 
                class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                @change="onJadwalSelected"
              >
                <option value="">Pilih jadwal</option>
                <option 
                  v-for="jadwal in jadwalList" 
                  :key="jadwal.id" 
                  :value="jadwal.id"
                  :disabled="isJadwalInPast(jadwal)"
                >
                  {{ jadwal.label || jadwal.nama_jadwal || jadwal.nama }} 
                  ({{ formatDateTime(jadwal.waktu_mulai) }} - {{ formatDateTime(jadwal.waktu_selesai) }})
                </option>
              </select>
              <p v-if="jadwalList.length === 0" class="text-sm text-red-500">Tidak ada jadwal tersedia</p>
              <p v-if="jadwalList.length > 0" class="text-sm text-gray-500 mt-1">{{ jadwalList.length }} jadwal tersedia</p>
            </div>
            
            <div v-if="selectedJadwalId" class="space-y-4">
              <div v-if="isActiveJadwal" class="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <svg class="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <p class="text-sm text-yellow-700">
                      <strong>Perhatian:</strong> Untuk jadwal ini, hanya waktu selesai yang dapat diubah dan harus diperpanjang (waktu lebih lama).
                    </p>
                  </div>
                </div>
              </div>
              <div class="flex flex-col md:flex-row md:space-x-4">
                <div class="mb-4 md:w-1/2">
                  <label class="block text-gray-700 text-sm font-bold mb-2" for="waktu-mulai">
                    Waktu Mulai
                  </label>
                  <Calendar
                    id="waktu-mulai"
                    v-model="editJadwalForm.waktu_mulai"
                    showTime
                    hourFormat="24"
                    dateFormat="dd/mm/yy"
                    class="w-full"
                    :disabled="isActiveJadwal"
                    :class="{'opacity-70 cursor-not-allowed': isActiveJadwal}"
                  />
                  <p v-if="isActiveJadwal" class="text-xs text-gray-500 mt-1">Waktu mulai tidak dapat diubah untuk jadwal ini</p>
                </div>
                <div class="mb-4 md:w-1/2">
                  <label class="block text-gray-700 text-sm font-bold mb-2" for="waktu-selesai">
                    Waktu Selesai
                  </label>
                  <Calendar
                    id="waktu-selesai"
                    v-model="editJadwalForm.waktu_selesai"
                    showTime
                    hourFormat="24"
                    dateFormat="dd/mm/yy"
                    class="w-full"
                  />
                </div>
              </div>
              
              <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="tempat">
                  Tempat
                </label>
                <input
                  id="tempat"
                  type="text"
                  v-model="editJadwalForm.tempat"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              
              <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="keterangan">
                  Keterangan
                </label>
                <textarea
                  id="keterangan"
                  v-model="editJadwalForm.keterangan"
                  rows="3"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                ></textarea>
              </div>
            </div>
            <div v-else class="py-4 text-center text-gray-500">
              Pilih jadwal untuk mengedit
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <Button
          @click="closeEditJadwalModal"
          label="Batal"
          severity="secondary"
          text
        />
        <Button
          @click="submitEditJadwal"
          :loading="submittingJadwal"
          :disabled="!selectedJadwalId || submittingJadwal"
          label="Simpan"
          severity="success"
        />
      </template>
    </DialogModal>
  </app-layout>
</template>

<script>
import { defineComponent } from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import DialogModal from '@/Jetstream/DialogModal.vue'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import Calendar from 'primevue/calendar'
import Checkbox from 'primevue/checkbox'
import Textarea from 'primevue/textarea' // Add this import
import { useToast } from 'primevue/usetoast'
import { useConfirm } from "primevue/useconfirm";
import ProgressBar from 'primevue/progressbar'
import BeritaAcaraEvaluasiPenawaran from '@/Components/DokumenPengadaan/BeritaAcaraEvaluasiPenawaran.vue'
import BeritaAcaraHasilPenawaran from '@/Components/DokumenPengadaan/BeritaAcaraHasilPenawaran.vue'
// import FileUpload from '../../Components/FileUpload.vue'
import FileUpload from '@/Components/FileUpload.vue'

export default defineComponent({
  components: {
    AppLayout,
    DialogModal,
    Toast,
    Button,
    Dropdown,
    Calendar,
    Checkbox,
    ProgressBar,
    BeritaAcaraEvaluasiPenawaran,
    BeritaAcaraHasilPenawaran,
    Textarea, // Add Textarea to components
    FileUpload,
  },

  props: {
    pengajuanList: {
      type: Array,
      required: true,
    },
    listConstraint: {
      type: Array,
      required: true
    },
    listJadwal: {
      type: Array,
      required: true
    },
    dokumenPengadaanId: {
      type: [String, Number],
      required: true
    },
    dokumenPengadaan: {
      type: Object,
      default: null
    },
    latestRejectionNote: {
      type: String,
      default: null
    },

  },

  setup() {
    const toast = useToast();
    const confirm = useConfirm();
    return { toast, confirm }
  },

  data() {
    return {
      currentUserId: this.$page.props.user.id || null, // Current user ID from Inertia auth prop
      dokumenPengadaanActors: [],  // Store all actors associated with this dokumen_pengadaan
      detailModalOpen: false,
      selectedPengajuan: null,
      isKoreksiMode: false,
      koreksiForm: {},
      isSubmitting: false,
      penilaianForm: {},
      penilaianLulus: {},
      catatan: null,
      hasPenilaian: false,
      baepFormOpen: false,
      bahpFormOpen: false,
      isLoadingBaep: false,
      isLoadingBahp: false,
      actors: [],
      actorsByRole: {},
      isLoadingActors: false,
      dokumenPengadaan: null,
      baepForm: {
        nomor_baep: '',
        tanggal_baep: '',
        attendees: []
      },
      bahpForm: {
        nomor_bahp: '',
        tanggal_bahp: '',
        attendees: []
      },
      confirmSetPemenangProgress: 0,
      baepModalOpen: false,
      bahpModalOpen: false,
      selectedDokumenPengadaanId: null,
      selectedPenyedia: null,
      undanganModalOpen: false,
      hasUndangan: false,
      undangan: {
        isShow: true,
        waktuMulai: null,
        waktuAkhir: null,
        statusKirimColor: 'text-red-600',
        tempat: '',
        disiapkan: '',
        hadir: '',
      },
      // Edit Jadwal properties
      editJadwalModalOpen: false,
      loadingJadwal: false,
      submittingJadwal: false,
      selectedJadwalId: null,
      isExtendSelesaiOnlyJadwal: false,
      editJadwalForm: {
        waktu_mulai: null,
        waktu_selesai: null,
        tempat: '',
        keterangan: ''
      },
      jadwalList: [],
      jadwalModalOpen: false,
      baepBahpConstraint: 'allow_penilaian', // Constraint name for BAEP and BAHP buttons
      setPemenangConstraint: 'allow_set_pemenang', // Constraint name for Set Pemenang button
      fileKlarifikasi: null,
      pdfModalOpen: false,
      pdfUrl: null,
      isLoadingPdf: false,
      pdfError: null,
      konfirmBataldDialog: false,
      disabledActive: false,
      isSubmittingVerifikasi: false,
      // Riwayat Evaluasi Ulang
      hasEvaluasiUlangHistory: false,
      loadingRiwayatEvaluasi: false,
      latestRiwayatEvaluasi: null,
    }
  },

  computed: {
    hasBaep() {
      console.log('Checking hasBaep:', {
        dokumenPengadaan: this.dokumenPengadaan,
        nomor: this.dokumenPengadaan?.nomor_baep,
        tanggal: this.dokumenPengadaan?.tanggal_baep
      });
      return this.dokumenPengadaan &&
             this.dokumenPengadaan.nomor_baep &&
             this.dokumenPengadaan.tanggal_baep;
    },
    hasBahp() {
      console.log('Checking hasBahp:', {
        dokumenPengadaan: this.dokumenPengadaan,
        nomor: this.dokumenPengadaan?.nomor_bahp,
        tanggal: this.dokumenPengadaan?.tanggal_bahp
      });
      return this.dokumenPengadaan &&
             this.dokumenPengadaan.nomor_bahp &&
             this.dokumenPengadaan.tanggal_bahp;
    },
    isPenilaianAllowed() {
      // Tidak boleh mengubah penilaian jika sudah ada pemenang
      if (this.hasPemenang(this.dokumenPengadaanId)) return false;
      // Check if the specified constraint is allowed in listConstraint
      return this.listConstraint && this.listConstraint[this.baepBahpConstraint] === true;
    },
    isSetPemenangAllowed() {
      // Check if setting pemenang is allowed based on constraint
      // AND there's exactly one pokja actor (role_id_set_pemenang = 8)
      return this.listConstraint && 
             this.listConstraint[this.setPemenangConstraint] === true && 
             this.pokjaActorsCount === 1;
    },
    isProposePemenangAllowed() {
      // For multiple pokja case: propose pemenang is allowed when:
      // 1. Setting pemenang is allowed by constraint
      // 2. There are multiple pokja (>1)
      // 3. No proposal exists yet
      
      // Debug logging
      console.log('Debug Propose Pemenang Conditions:', {
        listConstraint: this.listConstraint,
        setPemenangConstraint: this.setPemenangConstraint,
        constraintValue: this.listConstraint ? this.listConstraint[this.setPemenangConstraint] : 'NO_LIST_CONSTRAINT',
        pokjaActorsCount: this.pokjaActorsCount,
        hasProposedPemenang: this.hasProposedPemenang,
        dokumenPengadaanActors: this.dokumenPengadaanActors,
        currentUserId: this.currentUserId,
        finalResult: this.listConstraint && 
                     this.listConstraint[this.setPemenangConstraint] === true && 
                     this.pokjaActorsCount > 1 &&
                     !this.hasProposedPemenang
      });
      
      return this.listConstraint && 
             this.listConstraint[this.setPemenangConstraint] === true && 
             this.pokjaActorsCount > 1 &&
             !this.hasProposedPemenang;
    },
    isApprovePemenangAllowed() {
      // For multiple pokja case: approve pemenang is allowed when:
      // 1. Setting pemenang is allowed by constraint
      // 2. There are multiple pokja (>1)
      // 3. A proposal exists
      // 4. Current pokja has not yet approved
      return this.listConstraint && 
             this.listConstraint[this.setPemenangConstraint] === true && 
             this.pokjaActorsCount > 1 &&
             this.hasProposedPemenang &&
             this.currentPokjaActor &&
             !this.currentPokjaActor.is_setuju_pemenang;
    },
    isSetPemenangKolektifAllowed() {
      // For multiple pokja case: kolektif set pemenang is allowed when:
      // 1. Setting pemenang is allowed by constraint
      // 2. There are multiple pokja (>1)
      // 3. A proposal exists
      // 4. All pokja have approved
      return this.listConstraint && 
             this.listConstraint[this.setPemenangConstraint] === true && 
             this.pokjaActorsCount > 1 &&
             this.hasProposedPemenang &&
             this.allPokjaApproved;
    },
    pokjaActorsCount() {
      // Return the count of dokumen_pengadaan_actor with role_id 8 (pokja)
      if (!this.dokumenPengadaanActors) return 0;
      return this.dokumenPengadaanActors.filter(actor => actor.role_id === 8).length;
    },
    hasProposedPemenang() {
      // Check if any penawaran has been proposed as pemenang
      return this.pengajuanList.some(pengajuan => pengajuan.is_proposed_pemenang);
    },
    proposedPemenang() {
      // Get the penawaran that has been proposed as pemenang
      return this.pengajuanList.find(pengajuan => pengajuan.is_proposed_pemenang) || null;
    },
    currentPokjaActor() {
      // Get the current user's pokja actor record
      if (!this.dokumenPengadaanActors) return null;
      return this.dokumenPengadaanActors.find(actor => actor.user_id === this.currentUserId && actor.role_id === 8);
    },
    allPokjaApproved() {
      // Check if all pokja have approved the proposed pemenang
      if (!this.dokumenPengadaanActors) return false;
      const pokjaActors = this.dokumenPengadaanActors.filter(actor => actor.role_id === 8);
      return pokjaActors.length > 0 && pokjaActors.every(actor => actor.is_setuju_pemenang);
    },
    sortedPengajuanList() {
      if (!this.pengajuanList || this.pengajuanList.length === 0) return [];
      
      // Create a copy of the array to avoid mutating the original prop
      const sortedList = [...this.pengajuanList];
      
      return sortedList.sort((a, b) => {
        // Helper function to calculate total penawaran value
        const getTotalPenawaran = (pengajuan) => {
          if (!pengajuan.detail_penawaran_kepersertaan_pengadaan) return 0;
          return pengajuan.detail_penawaran_kepersertaan_pengadaan.reduce((sum, item) => 
            sum + (item.volume * item.harga_satuan), 0
          );
        };
        
        // Priority 1: Sort by evaluation status (lulus first)
        const aLulus = a.is_lulus_evaluasi ? 1 : 0;
        const bLulus = b.is_lulus_evaluasi ? 1 : 0;
        
        if (aLulus !== bLulus) {
          return bLulus - aLulus; // Descending: lulus evaluasi first
        }
        
        // Priority 2: Sort by total penawaran value (lowest first)
        const aTotalPenawaran = getTotalPenawaran(a);
        const bTotalPenawaran = getTotalPenawaran(b);
        
        return aTotalPenawaran - bTotalPenawaran; // Ascending: lowest price first
      });
    },
    getTotalSelisih() {
      if (!this.selectedPengajuan?.detail_penawaran_kepersertaan_pengadaan ||
          !this.selectedPengajuan?.dokumen_pengadaan?.detail_hps_dokumen_pengadaan) return 0

      let totalPenawaran = this.selectedPengajuan.detail_penawaran_kepersertaan_pengadaan.reduce((sum, item) =>
        sum + (item.volume * item.harga_satuan), 0)
      let totalHps = this.selectedPengajuan.dokumen_pengadaan.detail_hps_dokumen_pengadaan.reduce((sum, item) =>
        sum + (item.volume * item.harga_satuan), 0)
      return totalPenawaran - totalHps
    },
    getTotalPercentageDiff() {
      if (!this.selectedPengajuan?.detail_penawaran_kepersertaan_pengadaan ||
          !this.selectedPengajuan?.dokumen_pengadaan?.detail_hps_dokumen_pengadaan) return 0

      let totalPenawaran = this.selectedPengajuan.detail_penawaran_kepersertaan_pengadaan.reduce((sum, item) =>
        sum + (item.volume * item.harga_satuan), 0)
      let totalHps = this.selectedPengajuan.dokumen_pengadaan.detail_hps_dokumen_pengadaan.reduce((sum, item) =>
        sum + (item.volume * item.harga_satuan), 0)
      return ((totalPenawaran - totalHps) / totalHps) * 100
    },
    getTotalNilai() {
      if (!this.selectedPengajuan?.dokumen_pengadaan?.bobot_penilaian_dokumen_pengadaan) return 0

      return this.selectedPengajuan.dokumen_pengadaan.bobot_penilaian_dokumen_pengadaan.reduce((total, bobot) => {
        const nilai = this.penilaianForm[bobot.id] || 0
        return total + (nilai * bobot.persentase_bobot / 100)
      }, 0)
    },
    totalKoreksi() {
      if (!this.selectedPengajuan?.detail_penawaran_kepersertaan_pengadaan) return 0;

      return this.selectedPengajuan.detail_penawaran_kepersertaan_pengadaan.reduce((total, detail) => {
        const volume = detail.volume || 0;
        const hargaSatuanSesudah = this.koreksiForm[detail.id]?.harga_satuan_sesudah || 0;
        return total + (volume * hargaSatuanSesudah);
      }, 0);
    },
    totalSebelumKoreksi() {
      if (!this.selectedPengajuan?.detail_penawaran_kepersertaan_pengadaan) return 0;

      return this.selectedPengajuan.detail_penawaran_kepersertaan_pengadaan.reduce((total, detail) => {
        const volume = detail.volume || 0;
        const hargaSatuan = detail.harga_satuan || 0;
        return total + (volume * hargaSatuan);
      }, 0);
    },
    hasExistingKoreksi() {
      return this.selectedPengajuan?.detail_penawaran_kepersertaan_pengadaan?.some(
        detail => detail.koreksi_penawaran_kepersertaan_pengadaan != null
      );
    },
    isPpk() {
        const role = this.$page.props.session_role.role_display_name
        
        return ['ppk','administrator'].includes(role)
    },
    isFormValid() {
        
        return this.catatan && 
            this.catatan.trim().length > 0 ;
    },
    canAjukanVerifikasiPemenang() {
      // Check if user is pokja
      const role = this.$page.props.session_role?.role?.name;
      if (role !== 'pokja') return false;

      // Check if BAHP exists
      if (!this.hasBahp) return false;

      // Check if there's a winner
      if (!this.hasPemenang(this.dokumenPengadaanId)) return false;

      // Check if not already in verifikasi_pemenang_1f stage
      if (this.dokumenPengadaan?.kode_tahap === 'verifikasi_pemenang_1f') return false;

      return true;
    },
    isPokja() {
      const role = this.$page.props.session_role?.role?.name;
      return role === 'pokja';
    },
    isActiveJadwal() {
      // This computed property is now used to check if a jadwal is extend-selesai-only
      // We're repurposing it to avoid breaking too many templates
      return this.isExtendSelesaiOnlyJadwal;
    }
  },

  methods: {
    async checkSetPemenangEligibility() {
      try {
        // Get actors associated with this dokumen_pengadaan
        const response = await axios.get(route('dokumen-pengadaan.actors', this.dokumenPengadaanId));
        this.dokumenPengadaanActors = response.data || [];
        console.log('Loaded actors for set pemenang eligibility:', this.dokumenPengadaanActors);
      } catch (error) {
        console.error('Error loading actors for set pemenang eligibility:', error);
        this.dokumenPengadaanActors = [];
      }
    },
    formatNumber(number) {
      return new Intl.NumberFormat('id-ID').format(number)
    },

    getPercentageDiff(penawaran, hps) {
      return ((penawaran - hps) / hps) * 100
    },

    handlePriceInput(event, detailId) {
      // Remove non-numeric characters
      let value = event.target.value.replace(/[^0-9]/g, '');

      // Convert to number
      value = value ? parseInt(value) : 0;

      // Update the form
      this.koreksiForm[detailId].harga_satuan_sesudah = value;
    },

    showKoreksi(pengajuan) {
      this.isKoreksiMode = true;
      this.selectedPengajuan = pengajuan;
      this.koreksiForm = {};
      this.catatan = pengajuan.keterangan_penilaian;

      // Initialize koreksi form with current values
      if (pengajuan.detail_penawaran_kepersertaan_pengadaan) {
        pengajuan.detail_penawaran_kepersertaan_pengadaan.forEach(detail => {
          // Check for existing koreksi
          const existingKoreksi = detail.koreksi_penawaran_kepersertaan_pengadaan;

          this.koreksiForm[detail.id] = {
            detail_penawaran_kepersertaan_pengadaan_id: detail.id,
            harga_satuan_sebelum: detail.harga_satuan,
            harga_satuan_sesudah: existingKoreksi ? existingKoreksi.harga_satuan_sesudah : detail.harga_satuan,
            alasan_koreksi: existingKoreksi ? existingKoreksi.alasan_koreksi : ''
          };
        });
      }

      this.detailModalOpen = true;
    },

    showDetails(pengajuan) {
      this.isKoreksiMode = false;
      this.selectedPengajuan = pengajuan;
      this.penilaianForm = {};
      this.penilaianLulus = {};
      this.hasPenilaian = false;
      this.catatan = pengajuan.keterangan_penilaian;
      

      // Initialize penilaian form
      if (pengajuan.dokumen_pengadaan.bobot_penilaian_dokumen_pengadaan) {
        pengajuan.dokumen_pengadaan.bobot_penilaian_dokumen_pengadaan.forEach(bobot => {
          const existingPenilaian = pengajuan.penilaian_penyedia_dokumen_pengadaan?.find(
            p => p.id_bobot_penilaian_dokumen_pengadaan === bobot.id
          );

          if (existingPenilaian) {
            this.hasPenilaian = true;
            this.penilaianForm[bobot.id] = existingPenilaian.nilai;
            this.penilaianLulus[bobot.id] = existingPenilaian.is_lulus;
          } else {
            this.penilaianForm[bobot.id] = 0;
            this.penilaianLulus[bobot.id] = false;
          }
        });
      }

      this.detailModalOpen = true;
    },

    closeModal() {
      this.detailModalOpen = false;
      this.selectedPengajuan = null;
      this.catatan = null;
    },
    closeBatalModal() {
      this.detailModalOpen = false;
      this.selectedPengajuan = null;
      this.catatan = null;
    },

    validateNilai(event, bobotId) {
      let value = event.target.value
      if (value < 0) this.penilaianForm[bobotId] = 0
      if (value > 100) this.penilaianForm[bobotId] = 100
    },
    
    onLulusChange(bobotId) {
      // If checkbox is checked, set nilai to 100
      if (this.penilaianLulus[bobotId]) {
        this.penilaianForm[bobotId] = 100
      }
      // We don't reset the nilai when unchecked to allow users to manually set scores
    },

    async savePenilaian() {
      try {
        this.isSubmitting = true;
        

        await axios.post(route('penilaian.store'), {
          id_kepersertaan_pengadaan: this.selectedPengajuan.id,
          penilaian: Object.entries(this.penilaianForm).map(([bobotId, nilai]) => ({
            id_bobot_penilaian_dokumen_pengadaan: bobotId,
            nilai: nilai,
            is_lulus: this.penilaianLulus[bobotId] || false
          })),
          catatan: this.catatan
        });

        // Refresh using current page's route with progress indicator
        await this.$inertia.reload({
          preserveScroll: true,
          preserveState: true,
          only: ['pengajuanList'],
          onProgress: (progress) => {
            // Progress is handled by Inertia's built-in loading indicator
          }
        });

        this.$toast.add({
          severity: 'success',
          summary: 'Berhasil',
          detail: 'Data penilaian berhasil disimpan',
          life: 3000
        });

        this.detailModalOpen = false;
      } catch (error) {
        console.error('Error saving penilaian:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || 'Terjadi kesalahan saat menyimpan penilaian',
          life: 3000
        });
      } finally {
        this.isSubmitting = false;
        this.catatan = null;
      }
    },

    async saveKoreksi() {
      try {
        this.isSubmitting = true;

        await axios.post(route('koreksi.store'), {
          koreksi: Object.entries(this.koreksiForm).map(([detailId, values]) => ({
            detail_penawaran_kepersertaan_pengadaan_id: detailId,
            harga_satuan_sebelum: values.harga_satuan_sebelum,
            harga_satuan_sesudah: values.harga_satuan_sesudah,
            alasan_koreksi: values.alasan_koreksi
          })),
          id_kepersertaan_pengadaan: this.selectedPengajuan.id,
          catatan: this.catatan
        });

        // Refresh the data using Inertia reload
        await this.$inertia.reload({
          preserveScroll: true,
          only: ['pengajuanList']
        });

        this.$toast.add({
          severity: 'success',
          summary: 'Berhasil',
          detail: 'Data koreksi berhasil disimpan',
          life: 3000
        });

        this.detailModalOpen = false;
      } catch (error) {
        console.error('Error saving koreksi:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || 'Terjadi kesalahan saat menyimpan koreksi',
          life: 3000
        });
      } finally {
        this.isSubmitting = false;
        this.catatan = null;
      }
    },

    calculateTotal(details, field) {
      if (!details) return 0;
      return details.reduce((sum, detail) => {
        const volume = detail.detail_hps_dokumen_pengadaan?.volume || 0;
        return sum + ((detail[field] || 0) * volume);
      }, 0);
    },

    calculateKoreksiTotal() {
      if (!this.selectedPengajuan?.detail_penawaran_kepersertaan_pengadaan) return 0;

      return this.selectedPengajuan.detail_penawaran_kepersertaan_pengadaan.reduce((sum, detail) => {
        const volume = detail.volume || 0;
        const koreksiHarga = this.koreksiForm[detail.id]?.harga_satuan_sesudah || detail.harga_satuan || 0;
        return sum + (koreksiHarga * volume);
      }, 0);
    },

    calculateTotalHPS() {
      if (!this.selectedPengajuan?.detail_penawaran_kepersertaan_pengadaan) return 0;

      return this.selectedPengajuan.detail_penawaran_kepersertaan_pengadaan.reduce((sum, detail) => {
        const volume = detail.detail_hps_dokumen_pengadaan?.volume || 0;
        const hargaSatuan = detail.detail_hps_dokumen_pengadaan?.harga_satuan || 0;
        return sum + (hargaSatuan * volume);
      }, 0);
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    },
    async showBaepForm() {
      try {
        this.isLoadingBaep = true;
        this.isLoadingActors = true;

        // Get the current dokumen pengadaan data with its actors
        const response = await axios.get(`/dokumen-pengadaan/${this.dokumenPengadaanId}`);
        this.dokumenPengadaan = response.data;
        console.log('Updated dokumen pengadaan:', this.dokumenPengadaan);

        // Reset form
        this.baepForm = {
          nomor_baep: '',
          tanggal_baep: '',
          attendees: []
        };

        // If BAEP exists, populate the form with existing data
        if (this.hasBaep) {
          console.log('BAEP exists, populating form');
          this.baepForm.nomor_baep = this.dokumenPengadaan.nomor_baep;
          this.baepForm.tanggal_baep = this.dokumenPengadaan.tanggal_baep;

          // Get IDs of actors who were present
          if (this.dokumenPengadaan.dokumen_pengadaan_actor) {
            this.baepForm.attendees = this.dokumenPengadaan.dokumen_pengadaan_actor
              .filter(actor => actor.is_hadir_baep === 1)
              .map(actor => actor.id);
          }
        } else {
          console.log('No BAEP exists');
        }

        // Load actors first to ensure they're available
        await this.loadActors();

        // Update actor attendance based on existing BAEP data
        if (this.hasBaep && this.dokumenPengadaan.dokumen_pengadaan_actor) {
          Object.values(this.actorsByRole).forEach(actors => {
            actors.forEach(actor => {
              const existingActor = this.dokumenPengadaan.dokumen_pengadaan_actor.find(a => a.id === actor.id);
              if (existingActor) {
                actor.is_hadir_bahp = existingActor.is_hadir_baep === 1;
              }
            });
          });
        } else {
          // Set default values when no BAEP exists
          Object.values(this.actorsByRole).forEach(actors => {
            actors.forEach(actor => {
              actor.is_hadir_bahp = false;
            });
          });
        }

        this.baepFormOpen = true;
      } catch (error) {
        console.error('Error loading BAEP data:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || 'Gagal memuat data BAEP',
          life: 3000
        });
      } finally {
        this.isLoadingBaep = false;
        this.isLoadingActors = false;
      }
    },
    closeBaepForm() {
      this.baepFormOpen = false;
      this.baepForm = {
        nomor_baep: '',
        tanggal_baep: '',
        attendees: []
      };
      this.actorsByRole = {};
    },
    async loadActors() {
      try {
        if (!this.dokumenPengadaanId) {
          throw new Error('ID Dokumen pengadaan tidak ditemukan');
        }

        this.isLoadingActors = true;
        const response = await axios.get(route('dokumen-pengadaan.actors', this.dokumenPengadaanId));
        // Group actors by role
        this.actorsByRole = response.data.reduce((acc, actor) => {
          if (!acc[actor.role.name]) {
            acc[actor.role.name] = [];
          }
          if (actor.role.name === 'pokja') {
            acc[actor.role.name].push({
              id: actor.id,
              user: {
                name: actor.user.name,
                fullname: actor.user.fullname
              },
              is_hadir_bahp: actor.is_hadir_baep === 1,
              is_hadir_bahp: actor.is_hadir_bahp === 1
            });
          }
          return acc;
        }, {});

        console.log('Loaded actors by role:', this.actorsByRole);

        // Update attendees array based on actor attendance
        if (this.baepFormOpen) {
          this.baepForm.attendees = [];
          Object.values(this.actorsByRole).forEach(actors => {
            actors.forEach(actor => {
              if (actor.is_hadir_bahp) {
                this.baepForm.attendees.push(actor.id);
              }
            });
          });
        } else if (this.bahpFormOpen) {
          this.bahpForm.attendees = [];
          Object.values(this.actorsByRole).forEach(actors => {
            actors.forEach(actor => {
              if (actor.is_hadir_bahp) {
                this.bahpForm.attendees.push(actor.id);
              }
            });
          });
        }

        console.log('Updated attendees:', this.baepFormOpen ? this.baepForm.attendees : this.bahpForm.attendees);
      } catch (error) {
        console.error('Error loading actors:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || 'Gagal memuat data aktor',
          life: 3000
        });
        if (this.baepFormOpen) {
          this.closeBaepForm();
        } else if (this.bahpFormOpen) {
          this.closeBahpForm();
        }
      } finally {
        this.isLoadingActors = false;
      }
    },
    formatDateForAPI(date) {
    if (!date) return null;
    
    // Jika date adalah string, parse terlebih dahulu
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    // Format tanggal dengan timezone lokal
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  },
    async saveBaep() {
      this.isSubmitting = true;
      try {
        // Get array of actor IDs who are present
        const attendees = [];
        Object.values(this.actorsByRole).forEach(actors => {
          actors.forEach(actor => {
            if (actor.is_hadir_bahp) {
              attendees.push(actor.id);
            }
          });
        });

        const response = await axios.post(`/dokumen_pengadaan/baep/${this.dokumenPengadaanId}`, {
          nomor_baep: this.baepForm.nomor_baep,
          tanggal_baep: this.baepForm.tanggal_baep ? this.formatDateForAPI(this.baepForm.tanggal_baep) : null,
          attendees: attendees,
        });

        this.$toast.add({
          severity: 'success',
          summary: 'Sukses',
          detail: 'BAEP berhasil disimpan',
          life: 3000,
        });

        // Close form first
        this.closeBaepForm();

        // Refresh the dokumen pengadaan data for both selectedPengajuan and main dokumenPengadaan
        const dokumenResponse = await axios.get(`/dokumen-pengadaan/${this.dokumenPengadaanId}`);
        
        // Update main dokumenPengadaan to immediately show download buttons
        this.dokumenPengadaan = dokumenResponse.data;
        
        // Also update selectedPengajuan if it exists
        if (this.selectedPengajuan) {
          this.selectedPengajuan.dokumen_pengadaan = dokumenResponse.data;
        }
      } catch (error) {
        console.error('Error saving BAEP:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.error || 'Gagal menyimpan BAEP',
          life: 3000,
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    async showBahpForm() {
      try {
        this.isLoadingBahp = true;
        this.isLoadingActors = true;

        // Get the current dokumen pengadaan data with its actors
        const response = await axios.get(`/dokumen-pengadaan/${this.dokumenPengadaanId}`);
        this.dokumenPengadaan = response.data;
        console.log('Updated dokumen pengadaan:', this.dokumenPengadaan);

        // Reset form
        this.bahpForm = {
          nomor_bahp: '',
          tanggal_bahp: '',
          attendees: []
        };

        // If BAHP exists, populate the form with existing data
        if (this.hasBahp) {
          console.log('BAHP exists, populating form');
          this.bahpForm.nomor_bahp = this.dokumenPengadaan.nomor_bahp;
          this.bahpForm.tanggal_bahp = this.dokumenPengadaan.tanggal_bahp;

          // Get IDs of actors who were present
          if (this.dokumenPengadaan.dokumen_pengadaan_actor) {
            this.bahpForm.attendees = this.dokumenPengadaan.dokumen_pengadaan_actor
              .filter(actor => actor.is_hadir_bahp === 1)
              .map(actor => actor.id);
          }
        } else {
          console.log('No BAHP exists');
        }

        // Load actors first to ensure they're available
        await this.loadActors();

        // Update actor attendance based on existing BAHP data
        if (this.hasBahp && this.dokumenPengadaan.dokumen_pengadaan_actor) {
          console.log("Dokumen pengadaan actors:", this.dokumenPengadaan.dokumen_pengadaan_actor);
          Object.values(this.actorsByRole).forEach(actors => {
            actors.forEach(actor => {
              console.log('Actor ID:', actor.id);
              const existingActor = this.dokumenPengadaan.dokumen_pengadaan_actor.find(a => a.id === actor.id);
              if (existingActor) {
                console.log('Existing actor:', existingActor);
                console.log("Is hadir BAHP:", existingActor.is_hadir_bahp);
                actor.is_hadir_bahp = existingActor.is_hadir_bahp == 1;
                console.log('Updated is_hadir_bahp for actor', actor.id, ':', actor.is_hadir_bahp);
              }
            });
          });
        } else {
          // Set default values when no BAHP exists
          Object.values(this.actorsByRole).forEach(actors => {
            actors.forEach(actor => {
              actor.is_hadir_bahp = false;
            });
          });
        }

        this.bahpFormOpen = true;
      } catch (error) {
        console.error('Error loading BAHP data:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || 'Gagal memuat data BAHP',
          life: 3000
        });
      } finally {
        this.isLoadingBahp = false;
        this.isLoadingActors = false;
      }
    },
    closeBahpForm() {
      this.bahpFormOpen = false;
      this.bahpForm = {
        nomor_bahp: '',
        tanggal_bahp: '',
        attendees: []
      };
      this.actorsByRole = {};
    },
    async saveBahp() {
      this.isSubmitting = true;
      try {
        // Create actor_attendance object with actor IDs as keys and attendance status as values
        const actor_attendance = {};
        Object.values(this.actorsByRole).forEach(actors => {
          actors.forEach(actor => {
            actor_attendance[actor.id] = actor.is_hadir_bahp;
          });
        });

        const response = await axios.post(`/dokumen_pengadaan/bahp/${this.dokumenPengadaanId}`, {
          nomor_bahp: this.bahpForm.nomor_bahp,
          tanggal_bahp: this.bahpForm.tanggal_bahp ? this.formatDateForAPI(this.bahpForm.tanggal_bahp) : null,
          actor_attendance: actor_attendance
        });

        this.$toast.add({
          severity: 'success',
          summary: 'Berhasil',
          detail: 'BAHP berhasil disimpan',
          life: 3000,
        });

        // Close form first
        this.closeBahpForm();

        // Refresh the dokumen pengadaan data for both selectedPengajuan and main dokumenPengadaan
        const dokumenResponse = await axios.get(`/dokumen-pengadaan/${this.dokumenPengadaanId}`);
        
        // Update main dokumenPengadaan to immediately show download buttons
        this.dokumenPengadaan = dokumenResponse.data;
        
        // Also update selectedPengajuan if it exists
        if (this.selectedPengajuan) {
          this.selectedPengajuan.dokumen_pengadaan = dokumenResponse.data;
        }
      } catch (error) {
        console.error('Error saving BAHP:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.error || 'Gagal menyimpan BAHP',
          life: 3000,
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    toggleBahpAttendance(actorId) {
      if (this.bahpForm.attendees.includes(actorId)) {
        this.bahpForm.attendees = this.bahpForm.attendees.filter(id => id !== actorId);
      } else {
        this.bahpForm.attendees.push(actorId);
      }
    },

    confirmResetPemenang() {
      this.confirm.require({
        message: 'Apakah Anda yakin ingin mereset pemenang?',
        header: 'Konfirmasi Reset Pemenang',
        icon: 'pi pi-exclamation-triangle',
        acceptClass: 'p-button-danger',
        accept: async () => {
          try {
            const response = await axios.post(route('dokumen_pengadaan.reset_pemenang', this.dokumenPengadaanId));
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil',
              detail: response.data.message,
              life: 3000,
            });
            this.$inertia.reload();
          } catch (error) {
            console.log("ERROR Reset", error);
            if (error.response?.status === 422) {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: error.response.data.message,
                life: 3000,
              });
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Terjadi kesalahan saat mereset pemenang',
                life: 3000,
              });
            }
          }
        },
        reject: () => {}
      });
    },
    
    confirmProposePemenang(pengajuan) {
      this.confirm.require({
        message: 'Apakah Anda yakin ingin mengusulkan penyedia ini sebagai pemenang?',
        header: 'Konfirmasi Propose Pemenang',
        icon: 'pi pi-exclamation-triangle',
        acceptClass: 'p-button-success',
        accept: async () => {
          try {
            // Make the API call to propose pemenang using the correct route name with hyphens
            const response = await axios.post(route('dokumen-pengadaan.propose-pemenang', pengajuan.dokumen_pengadaan_id), {
              kepersertaan_pengadaan_id: pengajuan.id // Using pengajuan.id as kepersertaan_pengadaan_id since penawaran is KepersertaanPengadaan
            });
            
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil',
              detail: response.data.message || 'Berhasil mengusulkan pemenang',
              life: 3000,
            });
            this.$inertia.reload();
          } catch (error) {
            console.error('Error proposing pemenang:', error);
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: error.response?.data?.message || 'Terjadi kesalahan saat mengusulkan pemenang',
              life: 3000,
            });
          }
        },
        reject: () => {}
      });
    },

    async confirmSetPemenang(pengajuan) {
      // Reload actors to ensure we have the latest count
      await this.checkSetPemenangEligibility();
      
      // Verify on the frontend that there's exactly one pokja actor
      if (this.pokjaActorsCount !== 1) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Hanya boleh ada 1 pokja yang menetapkan pemenang.',
          life: 3000,
        });
        return;
      }

      this.confirm.require({
        message: 'Apakah Anda yakin ingin menetapkan penyedia ini sebagai pemenang?',
        header: 'Konfirmasi Set Pemenang',
        icon: 'pi pi-exclamation-triangle',
        acceptClass: 'p-button-success',
        accept: async () => {
          try {
            const response = await axios.post(route('dokumen-pengadaan.set-pemenang', pengajuan.dokumen_pengadaan_id), {
              kepersertaan_pengadaan_id: pengajuan.id
            });
            
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil',
              detail: response.data.message || 'Berhasil menetapkan pemenang',
              life: 3000,
            });
            this.$inertia.reload();
          } catch (error) {
            console.error('Error setting pemenang:', error);
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: error.response?.data?.message || 'Terjadi kesalahan saat menetapkan pemenang',
              life: 3000,
            });
          }
        },
        reject: () => {}
      });
    },
    
    confirmApprovePemenang(pengajuan) {
      this.confirm.require({
        message: 'Apakah Anda yakin ingin menyetujui penyedia ini sebagai pemenang?',
        header: 'Konfirmasi Approve Pemenang',
        icon: 'pi pi-exclamation-triangle',
        acceptClass: 'p-button-success',
        accept: async () => {
          try {
            const response = await axios.post(route('dokumen-pengadaan.approve-pemenang', pengajuan.dokumen_pengadaan_id), {
              kepersertaan_pengadaan_id: pengajuan.id
            });
            
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil',
              detail: response.data.message || 'Berhasil menyetujui pemenang',
              life: 3000,
            });
            this.$inertia.reload();
          } catch (error) {
            console.error('Error approving pemenang:', error);
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: error.response?.data?.message || 'Terjadi kesalahan saat menyetujui pemenang',
              life: 3000,
            });
          }
        },
        reject: () => {}
      });
    },
    
    confirmSetPemenangKolektif(pengajuan) {
      this.confirm.require({
        message: 'Apakah Anda yakin ingin menetapkan penyedia ini sebagai pemenang secara kolektif?',
        header: 'Konfirmasi Set Pemenang Kolektif',
        icon: 'pi pi-exclamation-triangle',
        acceptClass: 'p-button-success',
        accept: async () => {
          try {
            const response = await axios.post(route('dokumen-pengadaan.set-pemenang-kolektif', pengajuan.dokumen_pengadaan_id), {
              kepersertaan_pengadaan_id: pengajuan.id
            });
            
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil',
              detail: response.data.message || 'Berhasil menetapkan pemenang secara kolektif',
              life: 3000,
            });
            this.$inertia.reload();
          } catch (error) {
            console.error('Error setting pemenang kolektif:', error);
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: error.response?.data?.message || 'Terjadi kesalahan saat menetapkan pemenang secara kolektif',
              life: 3000,
            });
          }
        },
        reject: () => {}
      });
    },

    hasPemenang(dokumenPengadaanId) {
      return this.pengajuanList.some(p => p.dokumen_pengadaan_id === dokumenPengadaanId && p.is_pemenang);
    },

    formatDateTime(dateTimeString) {
      if (!dateTimeString) return '-';

      // Parse the datetime string
      const date = new Date(dateTimeString);

      // Format as "DD MMM YYYY, HH:MM:SS"
      return date.toLocaleString('id-ID', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    },
    
    formatCurrency(value) {
      if (value === null || value === undefined) return 'Rp 0';
      return 'Rp ' + this.formatNumber(value);
    },
    
    formatNumber(number) {
      if (number === null || number === undefined) return '0';
      return new Intl.NumberFormat('id-ID').format(number);
    },
    formatConstraintName(constraint) {
      if (!constraint) return '';

      // Convert "allow_pendaftaran" to "Allow Pendaftaran"
      return constraint
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    filterConstraints(constraints) {
      // Filter out constraints that we don't want to show
      // Only keep constraints that are being used by active jadwals
      const filteredConstraints = {};

      // Get active constraints from our jadwal list
      const activeConstraints = new Set();
      if (this.listJadwal && this.listJadwal.length > 0) {
        this.listJadwal.forEach(jadwal => {
          if (jadwal.jadwal.constraint) {
            activeConstraints.add(jadwal.jadwal.constraint);
          }
        });
      }

      // Only include constraints that appear in our jadwal list
      Object.keys(constraints).forEach(constraint => {
        if (activeConstraints.has(constraint)) {
          filteredConstraints[constraint] = constraints[constraint];
        }
      });

      return filteredConstraints;
    },
    formatJadwalName(jadwal) {
      if (!jadwal || !jadwal.jadwal) return '';

      // Use nama_jadwal if available, otherwise format kode_tahap
      if (jadwal.jadwal.nama_jadwal) {
        return jadwal.jadwal.nama_jadwal;
      }

      // Fallback to formatted kode_tahap
      const baseCode = jadwal.jadwal.kode_tahap.replace(/_\d+[a-z]*$/, '');
      return baseCode
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    getJadwalsForConstraint(constraintName) {
      if (!this.listJadwal || !constraintName) return [];

      // Filter jadwals that have this constraint
      return this.listJadwal.filter(jadwal =>
        jadwal.jadwal.constraint === constraintName
      );
    },
    showJadwalList() {
      this.jadwalModalOpen = true
    },
    closeJadwalModal() {
      this.jadwalModalOpen = false
    },
    showBaepModal(dokumenPengadaanId) {
      this.selectedDokumenPengadaanId = dokumenPengadaanId
      this.baepModalOpen = true
    },
    closeBaepModal() {
      this.baepModalOpen = false
      this.selectedDokumenPengadaanId = null
    },
    showBahpModal(dokumenPengadaanId) {
      this.selectedDokumenPengadaanId = dokumenPengadaanId
      this.bahpModalOpen = true
    },
    closeBahpModal() {
      this.bahpModalOpen = false
      this.selectedDokumenPengadaanId = null
    },
    showUndanganModal(pengajuan) {
      console.log('Showing undangan modal for pengajuan:', pengajuan);
      
      if (![null,'Terkirim'].includes(pengajuan.undangan_klarifikasi_status)) {
        this.hasUndangan = true;
      }else{
        this.hasUndangan = false;
        this.undangan.disiapkan = pengajuan.undangan_klarifikasi_disiapkan;
        this.undangan.hadir = pengajuan.undangan_klarifikasi_hadir;
        this.undangan.tempat = pengajuan.undangan_klarifikasi_tempat;
        this.undangan.waktuAkhir = pengajuan.undangan_klarifikasi_waktu_akhir;
        this.undangan.waktuMulai = pengajuan.undangan_klarifikasi_waktu_mulai;
      } 

      this.undanganModalOpen = true
      this.selectedPenyedia = pengajuan
    },
    clearUndangan(){
      this.undangan.disiapkan = '';
      this.undangan.hadir = "";
      this.undangan.tempat = "";
      this.undangan.waktuAkhir = "";
      this.undangan.waktuMulai = "";
      this.undangan.isShow = false;
      this.$inertia.reload();
    },
    closeUndangan() {
      this.undanganModalOpen = false
      this.selectedPenyedia = null
      this.hasUndangan = false
      // this.clearUndangan();
    },
    async kirimUndangan(selectedPenyedia) {
      try {
        this.isSubmitting = true;

        const responseSetUndangan = await axios.post('/dokumen-pengadaan/set-und', {
          penyedia_id: this.selectedPenyedia.penyedia_id,
          waktuMulai: this.undangan.waktuMulai,
          waktuAkhir: this.undangan.waktuAkhir,
          tempat: this.undangan.tempat,
          kepesertaaiin_id: this.selectedPenyedia.id,
          disiapkan : this.undangan.disiapkan,
          hadir : this.undangan.hadir,
        });
        /* validate response simpan setting undangan */
        if (responseSetUndangan.data.status === 'error') {
            throw new Error(responseSetUndangan.data.message);
        }


        const responseKirim = await axios.post('/dokumen-pengadaan/kirim', {
          penyedia_id: this.selectedPenyedia.penyedia_id,
          kepesertaaiin_id: this.selectedPenyedia.id
        });

        this.$toast.add({
          severity: 'success',
          summary: 'Berhasil',
          detail: responseKirim.data.message,
          life: 3000
        });

        setTimeout(() => {
          this.$inertia.reload();
          this.closeUndangan();
        }, 3000);
      } catch (error) {
        console.error('Error sending undangan:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || 'Gagal mengirim undangan',
          life: 3000
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    async setUndangan(selectedPenyedia) {
       try {
        this.isSubmitting = true;

        const response = await axios.post('/dokumen-pengadaan/set-und', {
          penyedia_id: this.selectedPenyedia.penyedia_id,
          waktuMulai: this.undangan.waktuMulai,
          waktuAkhir: this.undangan.waktuAkhir,
          tempat: this.undangan.tempat,
          kepesertaaiin_id: this.selectedPenyedia.id,
          disiapkan : this.undangan.disiapkan,
          hadir : this.undangan.hadir,
        });

        this.$toast.add({
          severity: 'success',
          summary: 'Berhasil',
          detail: response.data.message,
          life: 3000
        });
        setTimeout(() => {
          this.$inertia.reload();
          this.closeUndangan();
        }, 1000);
      } catch (error) {
        console.error('Error sending undangan:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || 'Gagal mengirim undangan',
          life: 3000
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    /* async uploadFileKlarifikasi(selectedPenyedia){
      console.log('Uploading file klarifikasi for selectedPenyedia:', this.selectedPenyedia);
      console.log('File:', this.fileKlarifikasi);
      if (!this.fileKlarifikasi) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Peringatan',
          detail: 'Silakan pilih file untuk diunggah',
          life: 3000
        });
        return;
      }else if (this.fileKlarifikasi.size > 2 * 1024 * 1024) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Peringatan',
          detail: 'Ukuran file terlalu besar, maksimal 2MB',
          life: 3000
        });
        return;
      }else if (this.fileKlarifikasi.type !== 'application/pdf') {
        this.$toast.add({
          severity: 'warn',
          summary: 'Peringatan',
          detail: 'Format file tidak valid, hanya PDF yang diperbolehkan',
          life: 3000
        });
        return;
      }else{
        try {
          this.isSubmitting = true
          ;
          const formData = new FormData();
          formData.append('file', this.fileKlarifikasi);
          formData.append('kepersertaan_id', this.selectedPenyedia.id);

          const response = await axios.post('/dokumen-pengadaan/up-file-klarifikasi', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          this.$toast.add({
            severity: 'success',
            summary: 'Berhasil',
            detail: response.data.message,
            life: 3000
          });
          setTimeout(() => {
            this.closeUndangan();
            this.$inertia.reload();
          }, 3000);
        } catch (error) {
          console.error('Error uploading file klarifikasi:', error);
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: error.response?.data?.message || 'Gagal mengunggah file klarifikasi',
            life: 3000
          });
        } finally {
          this.isSubmitting = false;
          this.fileKlarifikasi = null; // Reset the file input
        }
      }

    }, */
    /* async viewKlarifikasiFile(kepersertaanId) {
      try {
        this.isLoadingPdf = true;
        this.pdfError = null;
        this.pdfModalOpen = true;

        const response = await axios.post(`/dokumen-pengadaan/view-file-klarifikasi/${kepersertaanId}`, {}, {
         responseType: 'json'
        });

        if (response.data.status === 'success') {
          const { file_content: fileContent, file_name: fileName } = response.data.data;

          // Decode base64 ke binary string
          const byteCharacters = atob(fileContent);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          // Buat Blob dengan tipe MIME PDF
          const blob = new Blob([byteArray], { type: 'application/pdf' });

          // Buat URL object dari Blob untuk ditampilkan di <iframe>
          this.pdfUrl = URL.createObjectURL(blob);
        } else {
          this.pdfError = 'Gagal memuat file PDF';
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Gagal memuat file klarifikasi',
            life: 3000
          });
        }

        // Create a blob URL from the response
      } catch (error) {
        console.error('Error viewing klarifikasi file:', error);
        this.pdfError = 'Gagal memuat file PDF';
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Gagal memuat file klarifikasi',
          life: 3000
        });
      } finally {
        this.isLoadingPdf = false;
      }
    }, */

    closePdfModal() {
      this.pdfModalOpen = false;
      this.pdfUrl = null;
      this.pdfError = null;

      // Clean up blob URL to prevent memory leaks
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl);
      }
    },

    showDialog() {
      this.konfirmBataldDialog = true;
    },
    tutup() {
      this.konfirmBataldDialog = false;
      this.disabledActive = false;
      this.catatan = null;
    },
    async confirmBatal() {
      this.konfirmBataldDialog = false;
      this.disabledActive = true;
     
      try {
          const response = await axios.post(route('dokumen-pengadaan.batal-proses', this.dokumenPengadaanId),
            { catatan: this.catatan });
          
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil',
              detail: response.data.message,
              life: 3000,
            });
            this.tutup(); 
            this.$inertia.reload();
          } catch (error) {
            // Log detailed error information
              console.error('Error detail:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status
              });
            if (error.response?.status === 422) {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: error.response.data.message,
                life: 3000,
              });
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Terjadi kesalahan saat membatalkan dokumen pengadaan',
                life: 3000,
              });
            }
          }finally {
            this.konfirmBataldDialog = false;
            this.disabledActive = false;
            this.catatan = null;
          }
          
        },
    reject: () => {
      this.tutup();
    },
    // Edit Jadwal Methods
    showEditJadwalModal() {
      this.editJadwalModalOpen = true;
      this.loadJadwalList();
    },
    
    closeEditJadwalModal() {
      this.editJadwalModalOpen = false;
      this.selectedJadwalId = null;
      this.isExtendSelesaiOnlyJadwal = false;
      this.editJadwalForm = {
        waktu_mulai: null,
        waktu_selesai: null,
        tempat: '',
        keterangan: ''
      };
    },
    
    async loadJadwalList() {
      try {
        this.loadingJadwal = true;
        const response = await axios.get(route('dokumen-pengadaan.jadwal', this.dokumenPengadaanId));
        
        console.log('API response data:', response.data);
        
        // Process jadwal data to format it properly for PrimeVue Dropdown
        this.jadwalList = response.data.map(jadwal => {
          // Use the jadwal's own properties without relying on nested objects
          // This handles cases where jadwal.jadwal might be undefined
          return {
            id: jadwal.id,
            kode_jadwal: jadwal.kode_jadwal,
            // Use the direct fields from the API response
            kode_jadwal_label: jadwal.kode_jadwal_label || jadwal.kode_jadwal || 'Jadwal',
            waktu_mulai: jadwal.waktu_mulai,
            waktu_selesai: jadwal.waktu_selesai,
            tempat: jadwal.tempat,
            keterangan: jadwal.keterangan,
            // Add a simple string property for the dropdown to display
            label: jadwal.kode_jadwal_label || jadwal.nama || jadwal.kode_jadwal || 'Jadwal'
          };
        });
        
        console.log('Loaded jadwal list:', this.jadwalList);
      } catch (error) {
        console.error('Error loading jadwal list:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || 'Gagal memuat daftar jadwal',
          life: 3000
        });
      } finally {
        this.loadingJadwal = false;
      }
    },
    
    isJadwalInPast(jadwal) {
      // Get config for extend-selesai-only jadwals
      const extendSelesaiOnlyJadwals = ['upload_dokumen_penawaran'];
      const isExtendOnly = extendSelesaiOnlyJadwals.includes(jadwal.kode_jadwal);
      
      if (isExtendOnly) {
        // For extend-selesai-only, only check if waktu_selesai is in the past
        if (!jadwal.waktu_selesai) return false;
        const now = new Date();
        return new Date(jadwal.waktu_selesai) < now;
      }
      
      // For all other jadwals, no restrictions - never in past
      return false;
    },
    
    formatDateTime(dateTimeString) {
      if (!dateTimeString) return '-';
      const options = { 
        day: 'numeric', 
        month: 'long', 
        year: 'numeric',
        hour: '2-digit', 
        minute: '2-digit',
        hour12: false
      };
      return new Date(dateTimeString).toLocaleString('id-ID', options);
    },
    
    getSelectedJadwalLabel() {
      if (!this.selectedJadwalId) return '';
      const selectedJadwal = this.jadwalList.find(j => j.id === this.selectedJadwalId);
      // Use label property which we're now setting directly at the root level
      return selectedJadwal ? selectedJadwal.label || selectedJadwal.nama_jadwal || selectedJadwal.nama || 'Jadwal' : '';
    },
    
    onJadwalSelected() {
      if (!this.selectedJadwalId) return;
      
      const selectedJadwal = this.jadwalList.find(j => j.id === this.selectedJadwalId);
      if (!selectedJadwal) return;
      
      // Get config for extend-selesai-only jadwals
      const extendSelesaiOnlyJadwals = ['upload_dokumen_penawaran'];
      
      // Check if this jadwal is in the extend-selesai-only list
      this.isExtendSelesaiOnlyJadwal = extendSelesaiOnlyJadwals.includes(selectedJadwal.kode_jadwal);
      
      // For extend-selesai-only jadwals, check if waktu_selesai is in the past
      if (this.isExtendSelesaiOnlyJadwal) {
        const now = new Date();
        const waktuSelesai = selectedJadwal.waktu_selesai ? new Date(selectedJadwal.waktu_selesai) : null;
        
        if (waktuSelesai && waktuSelesai < now) {
          this.$toast.add({
            severity: 'warn',
            summary: 'Peringatan',
            detail: 'Jadwal ini tidak dapat diedit karena waktu selesai sudah berlalu',
            life: 3000
          });
          this.selectedJadwalId = null;
          return;
        }
      }
      
      // Load jadwal data into form
      this.editJadwalForm = {
        waktu_mulai: selectedJadwal.waktu_mulai ? new Date(selectedJadwal.waktu_mulai) : null,
        waktu_selesai: selectedJadwal.waktu_selesai ? new Date(selectedJadwal.waktu_selesai) : null,
        tempat: selectedJadwal.tempat || '',
        keterangan: selectedJadwal.keterangan || ''
      };
    },
    
    formatDateForApi(dateInput) {
      if (!dateInput) return null;
      
      // Ensure we have a Date object
      const dateObj = dateInput instanceof Date ? dateInput : new Date(dateInput);
      
      // Check if date is valid
      if (isNaN(dateObj.getTime())) {
        console.error('Invalid date input:', dateInput);
        return null;
      }
      
      const pad = (num) => String(num).padStart(2, '0');
      
      const year = dateObj.getFullYear();
      const month = pad(dateObj.getMonth() + 1); // getMonth() is 0-indexed
      const day = pad(dateObj.getDate());
      const hours = pad(dateObj.getHours());
      const minutes = pad(dateObj.getMinutes());
      const seconds = pad(dateObj.getSeconds());
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    async submitEditJadwal() {
      try {
        this.submittingJadwal = true;
        
        // Find the current jadwal object from jadwalList
        const currentJadwal = this.jadwalList.find(j => j.id === this.selectedJadwalId);
        if (!currentJadwal) {
          throw new Error('Jadwal tidak ditemukan');
        }
        
        const currentWaktuSelesai = new Date(currentJadwal.waktu_selesai);
        
        // For extend-selesai-only jadwals, validate that waktu_selesai is later than current
        if (this.isExtendSelesaiOnlyJadwal) {
          if (this.editJadwalForm.waktu_selesai <= currentWaktuSelesai) {
            throw new Error('Waktu selesai baru harus lebih lama dari waktu selesai saat ini');
          }
        }
        
        // Format dates for API - match the field names expected by the edit_jadwal controller method
        const formData = {
          pelaksanaan_jadwal_id: this.selectedJadwalId,
          // For extend-selesai-only, keep waktu_mulai; for others, allow change
          waktu_mulai: this.formatDateForApi(this.isExtendSelesaiOnlyJadwal ? currentJadwal.waktu_mulai : this.editJadwalForm.waktu_mulai),
          waktu_selesai: this.formatDateForApi(this.editJadwalForm.waktu_selesai),
          tempat: this.editJadwalForm.tempat || '',
          keterangan: this.editJadwalForm.keterangan || ''
        };
        
        const response = await axios.post(route('dokumen-pengadaan.edit-jadwal'), formData);
        
        this.$toast.add({
          severity: 'success',
          summary: 'Berhasil',
          detail: response.data.message,
          life: 3000
        });
        
        this.closeEditJadwalModal();
        this.$inertia.reload();
      } catch (error) {
        console.error('Error updating jadwal:', error);
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: error.response?.data?.message || error.message || 'Terjadi kesalahan saat menyimpan jadwal',
          life: 3000
        });
      } finally {
        this.submittingJadwal = false;
      }
    },

    confirmAjukanVerifikasiPemenang() {
      this.confirm.require({
        message: 'Apakah Anda yakin ingin mengajukan verifikasi pemenang ke PPK? Dokumen akan dipindah ke tahap verifikasi pemenang.',
        header: 'Konfirmasi Ajukan Verifikasi Pemenang',
        icon: 'pi pi-exclamation-triangle',
        acceptClass: 'p-button-success',
        accept: async () => {
          try {
            this.isSubmittingVerifikasi = true;
            
            const response = await axios.post(route('dokumen-pengadaan.ajukan-verifikasi-pemenang', this.dokumenPengadaanId));
            
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil',
              detail: response.data.message,
              life: 3000,
            });
            
            // Redirect to the specified URL
            if (response.data.redirect) {
              window.location.href = response.data.redirect;
            } else {
              // Fallback to reload if no redirect URL provided
              this.$inertia.reload();
            }
          } catch (error) {
            console.error('Error submitting verifikasi pemenang:', error);
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: error.response?.data?.message || 'Terjadi kesalahan saat mengajukan verifikasi pemenang',
              life: 3000,
            });
          } finally {
            this.isSubmittingVerifikasi = false;
          }
        },
        reject: () => {}
      });
    },

    getQualifiedRank(pengajuan) {
      // Get only qualified participants (lulus evaluasi)
      const qualifiedParticipants = this.sortedPengajuanList.filter(p => p.is_lulus_evaluasi);
      
      // Find the rank of this participant among qualified ones
      const rank = qualifiedParticipants.findIndex(p => p.id === pengajuan.id) + 1;
      
      return rank;
    },

    confirmWaktuMulaiSelection() {
    // Validate that both date and time are selected
    if (!this.undangan.waktuMulai) {
      this.$toast.add({
        severity: 'warn',
        summary: 'Peringatan',
        detail: 'Mohon pilih tanggal dan waktu terlebih dahulu',
        life: 3000
      });
      return;
    }

    // Hide the calendar overlay
    if (this.$refs.waktuMulaiCalendar) {
      this.$refs.waktuMulaiCalendar.overlayVisible = false;
    }
    this.undangan.waktuMulai = this.formatSelectedDateTime(this.undangan.waktuMulai);
    
  },

  cancelWaktuMulaiSelection() {
    // Hide the calendar overlay
    if (this.$refs.waktuMulaiCalendar) {
      this.$refs.waktuMulaiCalendar.overlayVisible = false;
    }
  },

  confirmWaktuAkhirSelection() {
    // Validate that both date and time are selected
    if (!this.undangan.waktuAkhir) {
      this.$toast.add({
        severity: 'warn',
        summary: 'Peringatan',
        detail: 'Mohon pilih tanggal dan waktu terlebih dahulu',
        life: 3000
      });
      return;
    }

    // Additional validation: waktu akhir should be after waktu mulai
    if (this.undangan.waktuMulai && this.undangan.waktuAkhir <= this.undangan.waktuMulai) {
      this.$toast.add({
        severity: 'warn',
        summary: 'Peringatan',
        detail: 'Waktu akhir harus setelah waktu mulai',
        life: 3000
      });
      return;
    }

    // Hide the calendar overlay
    if (this.$refs.waktuAkhirCalendar) {
      this.$refs.waktuAkhirCalendar.overlayVisible = false;
    }
    this.undangan.waktuAkhir = this.formatSelectedDateTime(this.undangan.waktuAkhir);
    console.log('Waktu akhir selected:', this.undangan.waktuAkhir);
    console.log('Data Undangan:', this.undangan);
    
    
    
  },

  cancelWaktuAkhirSelection() {
    // Hide the calendar overlay
    if (this.$refs.waktuAkhirCalendar) {
      this.$refs.waktuAkhirCalendar.overlayVisible = false;
    }
  },

  formatSelectedDateTime(dateTime) {
    if (!dateTime) return '';
    
     const date = new Date(dateTime);
  
    // Use Intl.DateTimeFormat with Indonesia timezone
    // Format to Indonesia local timezone in YYYY-MM-DD HH:MM:SS format
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    //const seconds = String(date.getSeconds()).padStart(2, '0'); // :${seconds}
    
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  },

  async checkEvaluasiUlangHistory() {
    try {
      const response = await axios.get(route('riwayat-evaluasi.check', this.dokumenPengadaanId));
      if (response.data.success) {
        this.hasEvaluasiUlangHistory = response.data.has_evaluasi_ulang_history;
        this.latestRiwayatEvaluasi = response.data.latest_riwayat;
      }
    } catch (error) {
      console.error('Error checking evaluasi ulang history:', error);
      // Silently fail - not critical
    }
  },
  
  async showHistoricEvaluasiModal() {
    try {
      this.loadingRiwayatEvaluasi = true;
      const response = await axios.get(route('riwayat-evaluasi.latest', this.dokumenPengadaanId));
      if (response.data.success && response.data.data) {
        // Navigate to the view page
        this.$inertia.visit(route('riwayat-evaluasi.view', {
          dokumenPengadaanId: this.dokumenPengadaanId,
          riwayatId: response.data.data.id
        }));
      } else {
        this.$toast.add({
          severity: 'info',
          summary: 'Info',
          detail: 'Tidak ada riwayat evaluasi ulang untuk dokumen ini',
          life: 3000
        });
      }
    } catch (error) {
      console.error('Error fetching historic evaluasi:', error);
      this.$toast.add({
        severity: 'error',
        summary: 'Error',
        detail: error.response?.data?.message || 'Gagal memuat riwayat evaluasi',
        life: 3000
      });
    } finally {
      this.loadingRiwayatEvaluasi = false;
    }
  },
  },
  async mounted() {
    try {
      const response = await axios.get(`/dokumen-pengadaan/${this.dokumenPengadaanId}`);
      this.dokumenPengadaan = response.data;
      console.log('Loaded dokumen pengadaan on mount:', this.dokumenPengadaan);
      
      // Load actors to verify setPemenang eligibility
      await this.checkSetPemenangEligibility();
      
      // Check for evaluasi ulang history
      await this.checkEvaluasiUlangHistory();
    } catch (error) {
      console.error('Error loading dokumen pengadaan:', error);
      this.$toast.add({
        severity: 'error',
        summary: 'Error',
        detail: error.response?.data?.message || 'Gagal memuat data dokumen pengadaan',
        life: 3000
      });
    }
  }
})
</script>
